import React, { useState, useEffect, useRef, createRef } from "react";
import styles from "./style.module.scss";
import BoardCard from "components/Dashboard/BoardCard";
import GaugeChart from "react-gauge-chart";
import HotTerms from "components/Dashboard/HotTerms";
import LineChartWrapper from "components/Dashboard/LineChartWrapper";
import { apiRequest, uploadFileToS3 } from "util/services";
import { trackReviewExported } from "util/productAnalytics";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import ReviewsList from "components/Dashboard/ReviewsList";
import CreateTaskTrelloModal from "components/Dashboard/TaskModalTrello";
import CreateTaskClickupModal from "components/Dashboard/TaskModalClickup";
import CreateTaskJiraModal from "components/Dashboard/TaskModelJira";
import { Modal } from "components/General/ModalFormComponents";
import CustomSummaryItem from "components/CustomSummary/customSummaryItem";
import {
  notification,
  Button,
  Spin,
  Input,
  Menu,
  Dropdown,
  Tag,
  Tooltip,
  message,
} from "antd";
import {
  DownOutlined,
  CloseOutlined,
  LoadingOutlined,
  ExclamationCircleOutlined,
  RetweetOutlined,
  DeleteOutlined,
  CheckOutlined,
  EditOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import * as actions from "redux/Dashboard/actions.js";
import CustomInput from "components/General/CustomInput";
import { useTranslation, Trans } from "react-i18next";
import { resolveApiErrorMessage } from "util/apiErrorMessage";
import { isAbortedResult } from "util/apiAvailability";
import {
  closeReviewRangeNotice,
  isReviewRangeTooLarge,
  notifyReviewRangeTooLarge,
  notifyWidgetError,
} from "util/reviewRangeLimit";
import { copyToClipboard } from "util/common";
import TopTopics from "../TopTopics";
import FileTypePopup from "helperComponents/FileTypePopup";
import BarChartWrapper from "../BarChartWrapper";
import { DASHBOARD_INTENT_COLORS } from "../../../constants/dashboardIntentColors";
import MLDropdown from "helperComponents/MLDropdown";
import { AIInsightsModal } from "pages/Dashboard/TopProblems";
import { InfoCircleOutlined } from "@ant-design/icons";
import CustomChart from "components/Charts";
import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { TreeSelect } from 'antd';
import topTopicsStyles from '../TopTopics/style.module.scss';

// Helper to find parent name by id in tree
function findParentNameById(parentId, options) {
  if (!parentId || !options) return null;
  for (const node of options) {
    if (node.value === parentId) return node.title;
    if (node.children) {
      const found = findParentNameById(parentId, node.children);
      if (found) return found;
    }
  }
  return null;
}

const SelectedTopicInfo = ({
  selectedTopicData,
  selectedTopic,
  setSelectedTopic,
  closeSelectedTopic,
  shared,
  toggleListCard,
  user,
  setSelectedTopicData,
  setSelected,
  topicsType,
  DashboardId,
  currentDashboardHash,
  activeTopic,
  setDisableDateRange,
  topicChanged,
  setTopicChanged,
  allItems,
  uniqueAllDates,
  fillZeros,
  isCombinedView = false,
}) => {

  const initialState = { createCustomTopicModal: false };
  const [newLabel, setNewLabel] = useState();
  const [localState, setState] = useState(initialState);
  const [allReviews, setAllReviews] = useState([]);
  const [numReviews, setNumReviews] = useState();
  const [selectedTags, setSelectedTags] = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [customTopicState, setCustomTopicState] = useState({
    top_words: selectedTopicData?.TopWords,
  });
  const [showNormalizedData, setShowNormalizedData] = useState(true);
  const [createModal, setCreateModal] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [createTaskModal, setCreateTaskModal] = useState(false);
  const [showAIInsightsModal, setShowAIInsightsModal] = useState(false);
  const [generationPivotOptions, setGenerationPivotOptions] = useState(null);
  const [insightTxt, setInsightTxt] = useState("");
  const [timeInterval, setTimeInterval] = useState(null);
  const [searchWord, setSearchWord] = useState("");
  const DashboardReducer = useSelector((state) => state.DashboardReducer);
  const [ratingPeriodLoading, setratingPeriodLoading] = useState(false);
  const [nps, setNps] = useState(selectedTopicData?.NPS || 0);
  const [participationPeriod, setParticipationPeriod] = useState(null);
  const [sentimentPeriod, setSentimentPeriod] = useState(null);
  const [participationPeriodLoading, setParticipationPeriodLoading] = useState(
    true
  );
  const [sentimentPeriodLoading, setSentimentPeriodLoading] = useState(true);
  const [volumeDaily, setVolumeDaily] = useState([]);
  const [sentimentDaily, setSentimentDaily] = useState([]);
  const [ratingsPeriod, setratingsPeriod] = useState(null);
  const [totalReviews, setTotalReviews] = useState(
    selectedTopicData?.Posts || 0
  );
  const [rawData, setrawData] = useState(0);
  const [avgSentiment, setAvgSentiment] = useState(0);
  const [
    isAvgSentimentGaugeDataLoading,
    setIsAvgSentimentGaugeDataLoading,
  ] = useState(true);
  const [intentDoughnutData, setIntentDoughnutData] = useState([]);
  const [
    isIntentDoughnutDataLoading,
    setIsIntentDoughnutDataLoading,
  ] = useState(true);
  const [ratingDoughnutData, setRatingDoughnutData] = useState([]);
  const [
    isRatingDoughnutDataLoading,
    setIsRatingDoughnutDataLoading,
  ] = useState(true);
  const [sentimentDoughnutData, setSentimentDoughnutData] = useState([]);
  const [
    isSentimentDoughnutDataLoading,
    setIsSentimentDoughnutDataLoading,
  ] = useState(true);
  const [hottermsLoading, setHottermsLoading] = useState(false);
  const [restaurantDoughnutData, setRestaurantDoughnutData] = useState([]);
  const [
    isRestaurantDoughnutDataLoading,
    setIsRestaurantDoughnutDataLoading,
  ] = useState(true);
  const [Time_Daily_Rating, setTime_Daily_Rating] = useState(0);
  // const [facebookReplies, setFacebookReplies] = useState([]);
  const [platformData, setPlatformData] = useState({});
  const [
    isPlatformDoughnutDataLoading,
    setIsPlatformDoughnutDataLoading,
  ] = useState(true);
  const [avgRating, setAvgRating] = useState(selectedTopicData?.AvgRating);
  const [switchPeriod, setSwitchPeriod] = useState(false);
  const dispatch = useDispatch();
  const searchControllerRef = useRef();
  // Widget requests (search, top topics, hot terms, ratings, decisions,
  // highlights) for the current filters. Each new search aborts the previous
  // set so slow requests don't pile up while the user keeps changing filters.
  const widgetsControllerRef = useRef();
  useEffect(
    () => () => {
      if (widgetsControllerRef.current) widgetsControllerRef.current.abort();
    },
    []
  );
  // The range notice belongs to this view's date range; drop it when the view goes away.
  useEffect(() => () => closeReviewRangeNotice(), []);
  const userReducer = useSelector((state) => state.userReducer);
  const theme = useSelector((state) => state.DashboardReducer.theme);
  const { t } = useTranslation();
  const history = useHistory();
  const [hottermsData, setHottermsData] = useState({});
  const [subscriptionStatus, setSubscriptionStatus] = useState();
  const [insightTitleTxt, setinsightTitleTxt] = useState("");
  const [numOfDocs, setNumOfDocs] = useState(10);
  const [filters, setFilters] = useState([]);
  const [topTopics, setTopTopics] = useState([]);
  const [selectedTopTopics, setSelectedTopTopics] = useState([]);
  const [topTopicsLoading, setTopTopicsLoading] = useState(true);
  const [npsInfo, setNpsInfo] = useState(null);
  const [showFileTypePopup, setShowFileTypePopup] = useState(false);
  const [fileType, setFileType] = useState("csv");
  const [onlySequences, setOnlySequences] = useState(false);
  const [downloadDataLoading, setDownloadDataLoading] = useState(false);
  const [highlights, setHighlights] = useState([]);
  const [reviewsLoaded, setReviewsLoaded] = useState(false);
  const [pivotOptions, setPivotOptions] = useState(null);
  const [multiLevelOptions, setMultiLevelOptions] = useState(null);
  const [selectedPivots, setSelectedPivots] = useState({});
  const [levelWisePivotSelections, setLevelWisePivotSelections] = useState({});
  const [restData, setRestData] = useState({});
  const [overLimitForHotterms, setOverLimitForHotterms] = useState(false);
  const [topicRatingData, setTopicRatingData] = useState([]);
  const [topicSentimentData, setTopicSentimentData] = useState([]);
  const [topicRatingsLoading, setTopicRatingsLoading] = useState(true);
  const skipFirstLoadAPICall = useRef(true);
  const [checkedTopicIds, setCheckedTopicIds] = useState([]);
  const [selectedTopicIds, setSelectedTopicIds] = useState([]);
  const feedbackUpdated = useRef(false);
  const [createInsightLoading, setCreateInsightLoading] = useState(false);
  const skipSearchAPICall = useRef(true);
  const [queryFilters, setQueryFilters] = useState({});

  const applyActiveTopicToPayload = (payload, filters = {}) => {
    const urlTopic = filters.selected_topic ?? queryFilters.selected_topic;
    const topicId =
      urlTopic?.id ?? selectedTopic?.id ?? selectedTopicData?.TopicId;
    if (topicId != null && topicId !== "") {
      payload.topic_id = topicId;
      payload.topic_type =
        filters.topics_type ?? queryFilters.topics_type ?? topicsType;
    }
  };
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(window.location.search);
  const [selectedTopicFromBars, setSelectedTopicFromBars] = useState({});
  const [actualDistributionData, setActualDistributionData] = useState({});
  const [selectedPivotsOperator, setSelectedPivotsOperator] = useState("AND");
  const [showAdditionalSearchPopup, setShowAdditionalSearchPopup] = useState(
    false
  );
  const [npsScale, setNpsScale] = useState([1, 10]);
  const [chartDataDownloadProgress, setChartDataDownloadProgress] = useState(0);
  const [
    downloadSentimentChartsDataLoading,
    setDownloadSentimentChartsDataLoading,
  ] = useState(false);
  const [
    downloadRatingChartsDataLoading,
    setDownloadRatingChartsDataLoading,
  ] = useState(false);

  const [repositionModalOpen, setRepositionModalOpen] = useState(false);
  const [repositionLoading, setRepositionLoading] = useState(false);
  const [parentOptions, setParentOptions] = useState([]);
  const [parentOptionsLoading, setParentOptionsLoading] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);
  const [repositionError, setRepositionError] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [renameValue, setRenameValue] = useState(selectedTopic?.label || "");
  const [renameLoading, setRenameLoading] = useState(false);
  const [renameSuccess, setRenameSuccess] = useState(false);
  const [renameError, setRenameError] = useState("");
  const [charCount, setCharCount] = useState((selectedTopic?.label || "").length);
  const minLen = 3, maxLen = 50;
  const [fraudDoughnutData, setFraudDoughnutData] = useState([]);
  const [isFraudDoughnutDataLoading, setIsFraudDoughnutDataLoading] = useState(true);

  // Add this useEffect after state declarations
  useEffect(() => {
    setRenameValue(selectedTopic?.label || "");
    setCharCount((selectedTopic?.label || "").length);
    setSelectedParent(selectedTopic?.parent_id ? selectedTopic.parent_id : 'none');
  }, [selectedTopic]);

  useEffect(() => {
    if (selectedTopicData?.Posts == null) return;
    setrawData(selectedTopicData.Posts);
    setTotalReviews(selectedTopicData.Posts);
  }, [selectedTopicData?.Posts, selectedTopicData?.TopicId]);

  useEffect(() => {
    const topicId = selectedTopic?.id ?? selectedTopicData?.TopicId;
    if (!isCombinedView || !topicId || !DashboardReducer?.dashboard?.ID) return;
    getSearchResults(false, 0, true);
  }, [
    isCombinedView,
    selectedTopic?.id,
    selectedTopicData?.TopicId,
    DashboardReducer?.dashboard?.ID,
  ]);

  useEffect(() => {
    const handleResize = () => {
      setNpsScale((prev) => {
        return [prev[0], prev[1]];
      });
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });
  const [decisionData, setDecisionData] = useState([]);
  const [decisionDataLoading, setDecisionDataLoading] = useState(false);
  const [selectedDecisions, setSelectedDecisions] = useState({});
  const [cursors, setCursors] = useState({});
  const [cursorNext, setCursorNext] = useState("");
  const [backWardCursors, setBackwardCursors] = useState({ "-1": null });
  const [dateBasedChartsPeriod, setDateBasedChartsPeriod] = useState("daily");
  const [hideEmptyReviewsTopics, setHideEmptyReviewsTopics] = useState(true);
  const isInitialRender = useRef(true);
  const [resetReviewsPageTopics, setResetReviewsPageTopics] = useState(false);
  const [selectedReviewIDs, setSelectedReviewIds] = useState([]);
  const [tweetsCheckList, setTweetsCheckList] = useState({});
  const [usersCheckList, setUsersCheckList] = useState({});

  useEffect(() => {
    if (params) {
      const values = Array.from(params);
      const queryObj = values.reduce((acc, [key, val]) => {
        if (
          key === "keyword" ||
          key === "pivotFilter" ||
          key === "top_topics" ||
          key === "level1OfSelected" ||
          key === "level2OfSelected" ||
          key === "selected_topic" ||
          key === "active_topic_data" ||
          key === "decisionFilter" ||
          key === "child_others" ||
          key === "parent_others" ||
          key === "hotterm"
        ) {
          acc[key] = JSON.parse(val);
        } else {
          acc[key] = val;
        }
        return acc;
      }, {});
      setQueryFilters(queryObj);
    }
  }, [history, search]);

  const updateQParams = (attr, val) => {
    params.delete(attr);
    params.append(attr, val);
    history.push({ search: params.toString() });
  };
  const handleClearAllTopTopics = () => {
    let items = document.getElementsByClassName("check-box-topic-for-filter");
    if (items?.length > 0) {
      for (let i = 0; i < items?.length; i++) {
        items[i].checked = false;
        items[i].indeterminate = false;
      }
      setSelectedTopicIds([]);
      setCheckedTopicIds([]);
    }
  };

  useEffect(() => {
    getSubscribtionStatus();
  }, []);

  const getSubscribtionStatus = () => {
    const payload = {
      user_id: user.uid,
    };

    user?.uid &&
      apiRequest("subscriptions/all", "POST", payload, true).then((result) => {
        if (!result.error && !result.cancel) {
          setSubscriptionStatus(result?.[0]);
        } else {
          notification.error({
            message: result.error,
          });
        }
      });
  };
  let timerating = true;
  const getHighlights = async (allReviews) => {
    setReviewsLoading(true);
    const url = "dashboards/highlights";
    const payload = {
      review_ids: allReviews?.map((review) => review.date_gpid),
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
    };
    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    // Superseded by a newer search, which reloads reviews and highlights and
    // owns reviewsLoading now.
    if (isAbortedResult(result)) return;
    if (result?.success) {
      setHighlights(result.success);
    } else {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.reviews_highlights"),
      });
    }
    setReviewsLoading(false);
  };
  useEffect(() => {
    if (reviewsLoaded) {
      console.log(`Getting highlights`);
      getHighlights(allReviews);
    }
  }, [reviewsLoaded]);
  useEffect(() => {
    if (!params.has("start_index")) {
      updateQParams("start_index", 0);
    }
    if (!params.has("page_offset")) {
      updateQParams("page_offset", 10);
    }
    history.push({ search: params.toString() });
  }, [queryFilters]);
  const ratingColors = {
    "0": "#59009C",
    "1": "#6E6980",
    "2": "#2900D5",
    "3": "#F774A3",
    "4": "#FFB6C1",
    "5": "#8A2BE2",
    "6": "#5F9EA0",
    "7": "#7FFF00",
    "8": "#D2691E",
    "9": "#FF7F50",
    "10": "#6495ED",
  };
  const initRatingDoughnutData = async (rating_percent_obj) => {
    if (rating_percent_obj) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];

      ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].forEach(
        (key) => {
          // Changed from > 1 to > 0 to include all non-zero values
          // You can also use > 0.1 if you want to exclude extremely small values
          if (rating_percent_obj[key] > 0) {
            datas.push(rating_percent_obj[key]);
            labels.push(key);
            backgroundColors.push(hexToRGBA(ratingColors[key], 0.8));
            hoverBackgroundColors.push(hexToRGBA(ratingColors[key], 0.5));
          }
        }
      );

      const ratingDoughnutData = {
        maintainAspectRatio: false,
        responsive: false,
        text: "Rating",
        labels: labels,
        ids: labels.filter((key) => rating_percent_obj[key] > 0),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };

      setRatingDoughnutData(ratingDoughnutData);
    }
  };
  const initSentimentDoughnutData = (sentiment_percent_obj = {}) => {
    if (sentiment_percent_obj) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];
      Object.keys(sentiment_percent_obj).map((key) => {
        if (sentiment_percent_obj[key] > 1) {
          datas.push(sentiment_percent_obj[key]);
          labels.push(sentimentMapping[key]);
          backgroundColors.push(hexToRGBA(sentimentColors[key], 0.8));
          hoverBackgroundColors.push(hexToRGBA(sentimentColors[key], 0.5));
        }
      });
      const sentimentdoughnutData = {
        maintainAspectRatio: false,
        responsive: false,
        text: "Sentiment",
        ids: Object.keys(sentiment_percent_obj).filter(
          (key) => sentiment_percent_obj[key] > 1
        ),
        labels: labels,
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };
      setSentimentDoughnutData(sentimentdoughnutData);
    }
  };



  const runOnlyOneRef = useRef(true);
  const skipOnce = useRef(true);
  useEffect(() => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    // To reset TopWords selection
    if (queryFilters.keyword?.length === 0) {
      setSelectedTags([]);
    } else {
      setSelectedTags(queryFilters.keyword);
    }
    if (DashboardReducer?.dashboard?.ID && !reviewsLoading) {
      if (runOnlyOneRef.current) {
        runOnlyOneRef.current = false;
        return;
      }
      if (
        topicChanged &&
        skipOnce.current &&
        !params.has("insightTopicSearch") &&
        (params.get("topics_type") === "custom" ||
          (params.get("topics_type") === "ai" &&
            params.get("view_type") === "trends"))
      ) {
        setTopicChanged(false);
        console.log("Topic changed");
        skipOnce.current = false;
        return;
      }
      setSelectedReviewIds([]);
      setTweetsCheckList({});
      setUsersCheckList({});
      updateQParams("start_index", 0);
      updateQParams("cursor_curr", null);
      setTopicChanged(false);
      console.log(`Making search API related calls`);
      setTopTopicsLoading(true);
      getSearchResults(false, 0, true);
      setParticipationPeriodLoading(true);
      setSentimentPeriodLoading(true);
      setratingPeriodLoading(true);
      setIsAvgSentimentGaugeDataLoading(true);
      setIsPlatformDoughnutDataLoading(true);
      setIsIntentDoughnutDataLoading(true);
      setIsRatingDoughnutDataLoading(true);
      setIsSentimentDoughnutDataLoading(true);
      setDecisionDataLoading(true);
    }
  }, [queryFilters, resetReviewsPageTopics]);

  useEffect(() => {
    if (skipFirstLoadAPICall.current) {
      skipFirstLoadAPICall.current = false;
      return;
    } else {
      console.log(`Get only reviews when page size changes`);
      updateQParams("start_index", 0);
      updateQParams("cursor_curr", null);
      getOnlyReviews(false, 0, true);
    }
  }, [numOfDocs]);
  useEffect(() => {
    if (DashboardReducer?.dashboard?.ID && volumeDaily.length > 0) {
      console.log(`get search results on switch period change`);
      getSearchResults(false, 1);
    }
  }, [switchPeriod]);
  useEffect(() => {
    if (!switchPeriod) {
      if (params.get("since") && params.get("until")) {
        const since = params.get("since");
        const until = params.get("until");
        const sinceDate = dayjs(since);
        const untilDate = dayjs(until);
        const noOfDays =
          since === until ||
            (untilDate.diff(sinceDate, "day") === 1 && since !== until)
            ? untilDate.diff(sinceDate, "day")
            : untilDate.diff(sinceDate, "day") + 1;
        const period =
          noOfDays < 30 ? "daily" : noOfDays < 366 ? "monthly" : "yearly";
        setDateBasedChartsPeriod(period);
      } else {
        setDateBasedChartsPeriod("monthly");
      }
    }
  }, [history, search]);

  const getTopTopics = async (updateIndex, flag = 0, reset) => {
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      sortByDate,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      fraud,
    } = queryFilters;

    let url = "dashboards/v2/search/top_topics";
    const payload = {
      start_index: reset
        ? 0
        : updateIndex
          ? updateIndex > 1
            ? updateIndex
            : startIndex + updateIndex
          : 0,
      num_docs: numOfDocs,
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    applyActiveTopicToPayload(payload, { selected_topic, topics_type });
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud) { payload.fraud = fraud; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;

    if (result.cancel || result.error || result.validation_error) {
      notifyWidgetError(result, t, "api_errors.top_topics");
      // setTopTopicsLoading(false);
      // setParticipationPeriodLoading(false);
      // setSentimentPeriodLoading(false);
      // setratingPeriodLoading(false);
      // setIsAvgSentimentGaugeDataLoading(false);
      // setIsPlatformDoughnutDataLoading(false);
      // setIsIntentDoughnutDataLoading(false);
      // setIsRatingDoughnutDataLoading(false);
      // setIsSentimentDoughnutDataLoading(false);
      // setReviewsLoading(false);
      // setIsRestaurantDoughnutDataLoading(false);
      // setTopicRatingsLoading(false);
    }
    if (!result.error && !result.cancel && !result.validation_error) {
      setTopTopics(result);
    }
    setTopTopicsLoading(false);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };
  const calculateDistributionDifference = (filtered, original) => {
    const result = {};
    for (const key in filtered) {
      result[key] = {};
      for (const subKey in filtered[key]) {
        result[key][subKey] =
          filtered[key][subKey].percentage - original[key][subKey].percentage;
      }
    }
    return result;
  };
  const generatePivotAnalysis = (data) => {
    if (data && Object.keys(data)?.length > 0) {
      const normalizedFilteredData = getNormalizedData(data.filtered);
      const normalizedInitialData = getNormalizedData(data.initial);
      setActualDistributionData(normalizedInitialData);
      initRestaurantDoughnutData(normalizedFilteredData, normalizedInitialData);
    }
  };
  const getNormalizedData = (data) => {
    if (data && Object.keys(data)?.length > 0) {
      const keys = Object.keys(data);
      const totalCounts = {};
      const normalizedData = {};

      keys.forEach((key) => {
        totalCounts[key] = Object.values(data[key]).reduce((a, b) => a + b, 0);
      });

      // Normalize the data
      keys.forEach((key) => {
        normalizedData[key] = {};
        for (const subKey in data[key]) {
          normalizedData[key][subKey] = {
            count: data[key][subKey],
            percentage: Math.round(
              (data[key][subKey] / totalCounts[key]) * 100
            ),
          };
        }
      });
      return normalizedData;
    }
  };
  const getHotterms = async () => {
    setHottermsLoading(true);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const ngramsArr = [1, 2, 3, 4];
    const dataObj = {};
    let aborted = false;
    const promises = ngramsArr.map(async (n_words) => {
      const {
        sentiment,
        intent,
        since,
        until,
        rating,
        top_topics,
        topics_operator,
        platform_id,
        match_date,
        hotterm,
        nps,
        keyword,
        pivotFilter,
        pivots_operator,
        sortByDate,
        topics_type,
        selected_topic,
        decisionFilter,
        child_others,
        parent_others,
        fraud,
      } = queryFilters;

      let url = "dashboards/v2/get/hotterm";
      const payload = {
        dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
        n_words: n_words,
        user_id: user?.uid,
      };
      if (since && until) {
        payload.since = since;
        payload.until = until;
      }
      if (sentiment) {
        payload.sentiment = sentiment;
      }
      if (intent) {
        payload.intent = intent;
      }
      if (rating) {
        payload.rating = rating;
      }
      if (hotterm?.term) {
        payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
      }
      if (keyword && keyword.length > 0) {
        payload.keyword = keyword;
      }
      if (match_date) {
        payload.match_date = match_date;
      }
      if (platform_id) {
        payload.platform_id = platform_id;
      }
      if (nps) {
        payload.nps = nps;
      }
      if (
        pivotFilter &&
        Object.keys(pivotFilter).length > 0 &&
        Object.values(pivotFilter)?.flat().length > 0
      ) {
        payload.pivotFilter = pivotFilter;
        payload.pivots_operator = pivots_operator;
      }
      if (top_topics && top_topics.length > 0) {
        payload.top_topics = top_topics;
        payload.topics_operator = topics_operator ? topics_operator : "AND";
        if (child_others?.length > 0) {
          payload.top_topics_others = true;
          payload.child_others = child_others;
        } else if (parent_others?.length > 0) {
          payload.top_topics_others = true;
          payload.parent_others = parent_others;
        } else {
          payload.top_topics_others = false;
        }
      }
      if (switchPeriod) {
        payload.volume_period = switchPeriod.toLowerCase();
        payload.sentiment_period = switchPeriod.toLowerCase();
        payload.ratings_period = switchPeriod.toLowerCase();
      } else {
        payload.volume_period = dateBasedChartsPeriod.toLowerCase();
        payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
        payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
      }
      // if (sortByDate) payload.sortByDate = true;
      applyActiveTopicToPayload(payload, { selected_topic, topics_type });
      if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
        payload.decisionFilter = decisionFilter;
      }
      if (fraud) { payload.fraud = fraud; }
      const selectedTpcs = {};
      for (let level = 1; level >= 1; level++) {
        if (params.has(`level${level}Selection`)) {
          const levelSelection = JSON.parse(
            params.get(`level${level}Selection`)
          );
          selectedTpcs[level] = levelSelection;
        } else {
          break;
        }
      }

      const maxLevel = Math.max(...Object.keys(selectedTpcs));
      if (maxLevel > 0) {
        payload.topic_id = selectedTpcs[maxLevel]?.id;
      }
      const result = await apiRequest(
        url,
        "POST",
        payload,
        true,
        widgetsControllerRef.current?.signal
      );
      if (isAbortedResult(result)) {
        aborted = true;
        return;
      }

      if (result && !result.error && !result.cancel) {
        if (result.data && result.data === -1) {
          setOverLimitForHotterms(true);
          return;
        } else {
          dataObj[n_words] = result;
          setOverLimitForHotterms(false);
          return;
        }
      } else {
        if (isReviewRangeTooLarge(result)) notifyReviewRangeTooLarge(result, t);
        setHottermsLoading(false);
        dataObj[n_words] = [];
        return;
      }
    });
    await Promise.all(promises);
    if (aborted) return;
    setHottermsData(dataObj);
    setHottermsLoading(false);
  };
  function convertSentimentToPercentage(data) {
    const convertItem = (item) => {
      const { negative, neutral, positive, unspecified } = item.sentiment;
      const total =
        (negative || 0) + (neutral || 0) + (positive || 0) + (unspecified || 0);
      if (total > 0) {
        const sentiment = {
          "0.0": {
            percentage: parseFloat(
              (((negative || 0) / total) * 100).toFixed(2),
              10
            ),
            value: negative || 0,
          },
          "0.5": {
            percentage: parseFloat(
              (((neutral || 0) / total) * 100).toFixed(2),
              10
            ),
            value: neutral || 0,
          },
          "1.0": {
            percentage: parseFloat(
              (((positive || 0) / total) * 100).toFixed(2),
              10
            ),
            value: positive || 0,
          },
          "-1": {
            percentage: parseFloat(
              (((unspecified || 0) / total) * 100).toFixed(2),
              10
            ),
            value: unspecified || 0,
          },
        };

        if (item.child) {
          item.child = item.child.map(convertItem);
        }

        return {
          ...item,
          sentiment,
        };
      } else {
        return {
          ...item,
          sentiment: {
            "0.0": {
              percentage: 0,
              value: 0,
            },
            "0.5": {
              percentage: 0,
              value: 0,
            },
            "1.0": {
              percentage: 0,
              value: 0,
            },
            "-1": {
              percentage: 0,
              value: 0,
            },
          },
        };
      }
    };

    return data.map(convertItem);
  }
  const convertIntoRatingData = (data) => {
    const convertItem = (item) => {
      const ratings = item.rating;
      // Calculate the total count of ratings and the weighted sum
      const totalRatings = Object.values(ratings).reduce(
        (sum, count) => sum + count,
        0
      );
      let averageRating = 0;
      if (totalRatings > 0) {
        const weightedSum = Object.entries(ratings).reduce(
          (sum, [rating, count]) => sum + rating * count,
          0
        );
        averageRating = (weightedSum / totalRatings).toFixed(2);
      }
      const reviewsCount = Object.values(item.rating)
        .map((x) => parseInt(x, 10))
        .reduce((acc, curr) => acc + curr, 0);
      if (item.child) {
        item.child = item.child.map(convertItem);
      }
      return {
        ...item,
        rating: {
          value: averageRating,
          reviewsCount: reviewsCount,
        },
      };
    };
    return data.map(convertItem);
  };
  const getTopicRating = async () => {
    setTopicRatingsLoading(true);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      sortByDate,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      fraud,
    } = queryFilters;

    let url = "dashboards/v2/get/sent-rating";
    const payload = {
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    applyActiveTopicToPayload(payload, { selected_topic, topics_type });
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud) { payload.fraud = fraud; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;

    if (result.cancel || result?.error) {
      notifyWidgetError(result, t, "api_errors.topics_rating");
      setTopicRatingsLoading(false);
    } else {
      if (!result.error && !result.cancel) {
        const convertedValuesIntoPercentages = convertSentimentToPercentage(
          result
        );
        const convertedRatings = convertIntoRatingData(result);
        const sortedRat = [...convertedRatings].sort((a, b) => {
          return b.rating?.value - a.rating?.value;
        });
        const sortedSent = [...convertedValuesIntoPercentages].sort((a, b) => {
          const totalA =
            a.sentiment["0.0"]?.value +
            a.sentiment["0.5"]?.value +
            a.sentiment["1.0"]?.value +
            a.sentiment["-1"]?.value;
          const totalB =
            a.sentiment["0.0"]?.value +
            a.sentiment["0.5"]?.value +
            a.sentiment["1.0"]?.value +
            a.sentiment["-1"]?.value;
          return totalB - totalA;
        });
        setTopicRatingData(sortedRat);
        setTopicSentimentData(adjustSentiments(sortedSent));
        setTopicRatingsLoading(false);
      }
    }
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };
  const getSearchResults = async (updateIndex, flag = 0, reset) => {
    setReviewsLoaded(false);
    setBackwardCursors({ "-1": null });
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      sortByDate,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      fraud,
    } = queryFilters;

    const platformId = DashboardReducer?.dashboard?.PlatformId;
    // const isFacebookPlatform =
    //   flag === 0 && (platformId === 9 || platformId === 10);
    setTopTopicsLoading(true);
    // Every run (including a period switch) refetches all widgets below, so
    // it supersedes whatever the previous run still has in flight. Reviews
    // stay on searchControllerRef (getOnlyReviews resets it).
    if (widgetsControllerRef.current) widgetsControllerRef.current.abort();
    widgetsControllerRef.current = new AbortController();
    if (flag === 0) {
      !updateIndex && setIsRestaurantDoughnutDataLoading(true);
      setReviewsLoading(true);
      closeReviewRangeNotice();
    }
    if (flag === 1) {
      setParticipationPeriodLoading(true);
    }
    if (flag === 2) {
      setSentimentPeriodLoading(true);
    }

    let url = "dashboards/v2/search";
    const payload = {
      start_index: reset
        ? 0
        : updateIndex
          ? updateIndex > 1
            ? updateIndex
            : startIndex + updateIndex
          : 0,
      num_docs: numOfDocs,
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    applyActiveTopicToPayload(payload, { selected_topic, topics_type });
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud) { payload.fraud = fraud; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    // Get Top Topics and Search results simultaneously
    getOnlyReviews(updateIndex, 0, reset);
    getTopTopics();
    getHotterms();
    getTopicRating();
    if ([33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId)) {
      getDecisionData();
    }
    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    // Superseded by a newer search, which owns the loading flags now.
    if (isAbortedResult(result)) return;

    // let triggerFacebookReplies = false;
    if (result.cancel || result.error || result.validation_error) {
      notifyWidgetError(result, t, "api_errors.search_results");
      // setTopTopicsLoading(false);
      // setParticipationPeriodLoading(false);
      // setSentimentPeriodLoading(false);
      // setratingPeriodLoading(false);
      // setIsAvgSentimentGaugeDataLoading(false);
      // setIsPlatformDoughnutDataLoading(false);
      // setIsIntentDoughnutDataLoading(false);
      // setIsRatingDoughnutDataLoading(false);
      // setIsSentimentDoughnutDataLoading(false);
      // setReviewsLoading(false);
      // setIsRestaurantDoughnutDataLoading(false);
      // setTopicRatingsLoading(false);
    } else if (!result.error && !result.cancel) {
      setPivotOptions(result.pivot_options ? result.pivot_options : {});
      setVolumeDaily(result.VolumeDaily || []);
      setParticipationPeriod(
        participationPeriod
          ? participationPeriod
          : result?.VolumeDaily
            ? determinePeriod(result?.VolumeDaily[0]?.day)
            : "Monthly"
      );
      setratingsPeriod(
        ratingsPeriod
          ? ratingsPeriod
          : result?.VolumeDaily
            ? determinePeriod(result?.VolumeDaily[0]?.day)
            : "Monthly"
      );
      setSentimentPeriod(
        sentimentPeriod
          ? sentimentPeriod
          : result?.VolumeDaily
            ? determinePeriod(result?.VolumeDaily[0]?.day)
            : "Monthly"
      );
      setAvgSentiment(result?.avgSentiment || 0);
      initIntentDoughnutData(result.intentPercents || []);
      setTime_Daily_Rating(result.RatingsDaily);
      initRatingDoughnutData(result.ratingPercents || []);
      initSentimentDoughnutData(result.sentimentPercents || []);
      setSentimentDaily(result.SentimentDaily || []);
      setNpsInfo(result?.nps_dist);
      if (result?.npsScale) {
        const scale = result.npsScale;
        setNpsScale([
          parseInt(scale.split(" to ")[0], 10),
          parseInt(scale.split(" to ")[1], 10),
        ]);
      }
      setNumReviews(result.total_num_docs);
      setrawData(result.total_num_docs || 0);
      if (DashboardReducer.insightBasedSearch) {
        // scrollToElement("reviews_list");
      }
      if (result.pivotData?.initial && result.pivotData?.filtered) {
        generatePivotAnalysis(result.pivotData);
      }
      // triggerFacebookReplies =
      //   isFacebookPlatform && ((result || {}).docs || []).length > 0;
      // if (triggerFacebookReplies) {
      //   getFacebookReplies(result.docs);
      // }
      initPlatformDoughnutData((result || {}).PlatformCount || []);
      setTime_Daily_Rating(result.RatingsDaily);
      setratingPeriodLoading(false);
      setAvgRating(result?.avgRating || 0);
      setNps(result?.nps || 0);
      initFraudDoughnutData(result.fraud_dist || {});
      setIsFraudDoughnutDataLoading(false);
    }
    // else if (result.error) {
    //   notification.error({
    //     message: result.error,
    //   });
    // }
    setParticipationPeriodLoading(false);
    setIsAvgSentimentGaugeDataLoading(false);
    setIsSentimentDoughnutDataLoading(false);
    setIsPlatformDoughnutDataLoading(false);
    setIsRatingDoughnutDataLoading(false);
    setIsIntentDoughnutDataLoading(false);
    setSentimentPeriodLoading(false);
    setratingPeriodLoading(false);
    //Pivot chart loading state off when data is retrived
    setIsRestaurantDoughnutDataLoading(false);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    setIsFraudDoughnutDataLoading(false);
  };

  // if you are on page 2 and you click the hide reviews option then it bring you back to page 1
  useEffect(() => {
    if (isInitialRender.current) {
      //Skipping the intial render
      isInitialRender.current = false;
      return;
    }
    updateQParams("start_index", 0);
    updateQParams("cursor_curr", null);

    setSelectedReviewIds([]);
    setTweetsCheckList({});
    setUsersCheckList({});

    getOnlyReviews(0, 0, true);
  }, [hideEmptyReviewsTopics]);

  const getOnlyReviews = async (updateIndex, flag = 0, reset) => {
    setReviewsLoaded(false);
    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      sortByDate,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      include_empty_reviews,
      fraud,
    } = queryFilters;
    const start_index = params.get("start_index");
    const page_offset = params.get("page_offset");
    const cursor_curr = params.get("cursor_curr");
    if (flag === 0) {
      setReviewsLoading(true);
      if (searchControllerRef.current) {
        searchControllerRef.current.abort();
      }
      const controller = new AbortController();
      searchControllerRef.current = controller;
    }

    let url = "dashboards/v2/get/reviews";
    const payload = {
      start_index: reset ? 0 : parseInt(start_index, 10),
      num_docs: parseInt(page_offset, 10),
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      user_id: user?.uid,
      hide_empty: hideEmptyReviewsTopics,
    };
    if (!reset && cursor_curr && cursor_curr !== "null") {
      payload.cursor_next = cursor_curr;
    }
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    applyActiveTopicToPayload(payload, { selected_topic, topics_type });
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud) { payload.fraud = fraud; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (include_empty_reviews === "true") {
      payload.include_empty_reviews = true;
    }
    const result = await apiRequest(
      url,
      "POST",
      payload,
      true,
      searchControllerRef.current?.signal
    );
    // Aborted by a newer reviews request (paging or a new search), which owns
    // reviewsLoading now.
    if (isAbortedResult(result)) return;

    // let triggerFacebookReplies = false;
    if (
      result.cancel ||
      result?.error ||
      Object.keys(result)?.length === 0 ||
      result.validation_error
    ) {
      notification.error({
        message: resolveApiErrorMessage(result, t, "api_errors.loading_reviews"),
      });
      // Highlights (which normally clear it) only run after reviews load, so
      // without this a failed request (e.g. a 503) leaves the list disabled.
      setReviewsLoading(false);
      // setTopTopicsLoading(false);
      // setParticipationPeriodLoading(false);
      // setSentimentPeriodLoading(false);
      // setratingPeriodLoading(false);
      // setIsAvgSentimentGaugeDataLoading(false);
      // setIsPlatformDoughnutDataLoading(false);
      // setIsIntentDoughnutDataLoading(false);
      // setIsRatingDoughnutDataLoading(false);
      // setIsSentimentDoughnutDataLoading(false);
      // setReviewsLoading(false);
      // setIsRestaurantDoughnutDataLoading(false);
      // setTopicRatingsLoading(false);
      return;
    }
    if (!result.error && !result.cancel) {
      if (flag === 0) {
        setAllReviews(result.docs);
        setTimeInterval(result.timeInterval);
        setStartIndex(reset ? 0 : start_index);
      }
      if (feedbackUpdated?.current) {
        feedbackUpdated.current = false;
      }
      setCursors({
        prev: result.cursor_before,
        next: result.cursor_next,
      });
      setBackwardCursors((prev) => {
        return {
          ...prev,
          [start_index]: result.cursor_next,
        };
      });
      const backWard_ids = {
        ...backWardCursors,
        [start_index]: result.cursor_next,
      };
      updateQParams("cursor_next", result.cursor_next);

      if (start_index === "0") {
        updateQParams("cursor_before", null);
      } else {
        const b_cursor =
          backWard_ids[(parseInt(start_index, 10) - 2).toString()];
        setBackwardCursors((prev) => {
          return {
            ...prev,
            [(parseInt(start_index, 10) - 2).toString()]:
              b_cursor !== undefined ? b_cursor : params.get("cursor_before"),
          };
        });
        updateQParams(
          "cursor_before",
          b_cursor !== undefined ? b_cursor : params.get("cursor_before")
        );
      }
      setReviewsLoaded(true);
      // triggerFacebookReplies =
      //   isFacebookPlatform && ((result || {}).docs || []).length > 0;
      // if (triggerFacebookReplies) {
      //   getFacebookReplies(result.docs);
      // }
    }

    dispatch({
      type: actions.UPDATE_Dashboard,
      payload: {
        loading: false,
      },
    });
  };

  // const getFacebookReplies = async (resReviews = []) => {
  //   setReviewsLoading(true);
  //   const url = "dashboards/get_facebook_replies";
  //   const payload = {
  //     comment_ids: (resReviews.length > 0 ? resReviews : allReviews).map(
  //       ({ DocId }) => {
  //         return DocId;
  //       }
  //     ),
  //     firebase_id: DashboardReducer.dashboard.UserId,
  //   };
  //   const result = await apiRequest(url, "POST", payload, true);
  //   if (result.success) {
  //     setFacebookReplies(result.success);
  //   } else {
  //     notification.error({
  //       message: result.error,
  //     });
  //   }
  //   setReviewsLoading(false);
  // };

  const handleSearchWord = (tag, checked, isFromReviewsSection) => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    searchControllerRef.current = new AbortController();
    const selectedTags = params.has("keyword")
      ? JSON.parse(params.get("keyword"))
      : [];
    if (
      tag &&
      checked &&
      selectedTags.filter((item) => item.type === "search").length >= 1
    ) {
      setShowAdditionalSearchPopup(true);
      return;
    }
    const nextSelectedTags = checked
      ? tag
        ? [...selectedTags, { label: tag, type: "search" }]
        : selectedTags
      : selectedTags.filter((t) => t.label !== tag);
    updateQParams("keyword", JSON.stringify(nextSelectedTags));
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenKeywords: nextSelectedTags,
      },
    });
    setSearchWord("");
    if (!isFromReviewsSection) {
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: true,
        },
      });
    }
  };

  const handleCreateInsight = async () => {
    setDisabled(true);
    if (!insightTxt) {
      notification.error({ message: "Insight can't be empty" });
      return;
    }
    setCreateInsightLoading(true);
    const searchState = {
      ...DashboardReducer?.searchState,
      chosenDate: params.has("match_date") ? params.get("match_date") : "",
      chosenDocRating: params.has("rating") ? params.get("rating") : "",
      chosenHotTerm: params.has("hotterm")
        ? JSON.parse(params.get("hotterm"))
        : "",
      chosenIntent: params.has("intent") ? params.get("intent") : "",
      chosenKeywords: params.has("keyword")
        ? JSON.parse(params.get("keyword"))
        : [],
      chosenNPS: params.has("nps") ? params.get("nps") : "",
      chosenPlatformName: params.has("platform_id")
        ? platformIdsANdNamesMap[params.get("platform_id")]
        : "",
      chosenSentiment: params.has("sentiment") ? params.get("sentiment") : "",
      chosenTopTopic: params.has("top_topics")
        ? JSON.parse(params.get("top_topics"))
        : [],
      dateRange:
        params.has("since") && params.has("until")
          ? [params.get("since"), params.get("until")]
          : [],
      selectedDaysRange: params.has("daysRange")
        ? params.get("daysRange")
        : DashboardReducer?.searchState?.selectedDaysRange,
      topicsOperator:
        params.has("top_topics") && params.has("topics_operator")
          ? params.get("topics_operator")
          : "OR",
      pivotFilter: params.has("pivotFilter")
        ? JSON.parse(params.get("pivotFilter"))
        : {},
      pivots_operator:
        params.has("pivotFilter") && params.has("pivots_operator")
          ? pivots_operator
          : "AND",
      decisionFilter: params.has("decisionFilter")
        ? JSON.parse(params.get("decisionFilter"))
        : {},
    };
    //add topic id and topic type to the searchState
    searchState.topic_id = selectedTopicData.TopicId;
    searchState.topic_type = topicsType;
    const pathSegments = pathname?.split('/');
    const sourceKey = pathSegments[2];

    if(sourceKey){
      searchState.source_key = sourceKey
    }

    const ratingTpcs = {};
    for (let l = 1; l >= 1; l++) {
      if (params.has(`level${l}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${l}Selection`));
        ratingTpcs[`level${l}Selection`] = levelSelection;
      } else {
        break;
      }
    }
    if (params.has("top_topics")) {
      if (params.has("child_others")) {
        searchState.top_topics_others = true;
        searchState.child_others = JSON.parse(params.get("child_others"));
      } else if (params.has("parent_others")) {
        searchState.top_topics_others = true;
        searchState.parent_others = JSON.parse(params.get("parent_others"));
      } else {
        searchState.top_topics_others = false;
      }
    }
    const payload = {
      dashboard_id: `${DashboardId}`,
      insight: insightTxt,
      insight_title: insightTitleTxt,
      searchState: { ...searchState, ...ratingTpcs },
      timeInterval,
      total_num_docs: numReviews,
      reporter: userReducer.IsExpert ? 2 : 1,
    };
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      sortByDate,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      fraud,
    } = queryFilters;
    const search_payload = {
      dashboard_id: parseInt(DashboardId, 10),
      start_index: 0,
      num_docs: numOfDocs,
      user_id: user?.uid,
    };
    if (since && until) {
      search_payload.since = since;
      search_payload.until = until;
    }
    if (sentiment) {
      search_payload.sentiment = sentiment;
    }
    if (intent) {
      search_payload.intent = intent;
    }
    if (rating) {
      search_payload.rating = rating;
    }
    if (hotterm?.term) {
      search_payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      search_payload.keyword = keyword;
    }
    if (match_date) {
      search_payload.match_date = match_date;
    }
    if (platform_id) {
      search_payload.platform_id = platform_id;
    }
    if (nps) {
      search_payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      search_payload.pivotFilter = pivotFilter;
      search_payload.pivots_operator = pivots_operator;
    }
    if (top_topics && top_topics.length > 0) {
      search_payload.top_topics = top_topics;
      search_payload.topics_operator = topics_operator
        ? topics_operator
        : "AND";
      if (child_others?.length > 0) {
        search_payload.top_topics_others = true;
        search_payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        search_payload.top_topics_others = true;
        search_payload.parent_others = parent_others;
      } else {
        search_payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      search_payload.volume_period = switchPeriod.toLowerCase();
      search_payload.sentiment_period = switchPeriod.toLowerCase();
      search_payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      search_payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      search_payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      search_payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) search_payload.sortByDate = true;
    applyActiveTopicToPayload(search_payload, { selected_topic, topics_type });
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      search_payload.decisionFilter = decisionFilter;
    }
    if (fraud) { search_payload.fraud = fraud; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    if (Object.keys(search_payload)?.length > 0) {
      payload.search_payload = search_payload;
    }

    const result = await apiRequest(
      "dashboards/insights/create",
      "POST",
      payload,
      true
    );
    if (result.cancel || result.error) {
      notification.error({
        message: result.error ? result.error : "Failed to post Insight",
      });
    } else {
      notification.success({
        message: (
          <span>
            Insight created successfully.
            <br />
            Go to{" "}
            <a
              onClick={() => {
                for (let l = 1; l >= 1; l++) {
                  if (params.has(`level${l}Selection`)) {
                    params.delete(`level${l}Selection`);
                    history.push({ search: params.toString() });
                    dispatch({
                      type: actions.UPDATE_SEARCH_STATE,
                      payload: {
                        [`selectedL${l}Topic`]: null,
                      },
                    });
                  } else {
                    break;
                  }
                }
                [
                  "sentiment",
                  "intent",
                  "rating",
                  "top_topics",
                  "topics_operator",
                  "platform_id",
                  "match_date",
                  "hotterm",
                  "nps",
                  "keyword",
                  "pivotFilter",
                  "pivots_operator",
                  "view_type",
                  "topics_type",
                  "selected_topic",
                  "insightTopicSearch",
                  "insightTopicClosed",
                  "start_index",
                  "page_offset",
                  "decisionFilter",
                  "cursor_next",
                  "cursor_curr",
                  "cursor_before",
                  "savedSearchID",
                  "child_others",
                  "parent_others",
                  "fraud",
                ].forEach((item) => params.delete(item));
                history.push({
                  pathname: `/console/insights/${DashboardReducer.dashboard?.ID}`,
                  search: params.toString(),
                });
              }}
            >
              insights page
            </a>
          </span>
        ),
      });
    }
    setCreateInsightLoading(false);
    setCreateModal(false);
    // getInsights(DashboardId);
    setInsightTxt("");
    setinsightTitleTxt("");
  };

  const handleAIInsightGeneration = async (payload) => {
    try {
      const response = await apiRequest(
        "dashboards/gen-insights",
        "POST",
        payload,
        true
      );
      if (response?.error) throw new Error(response.error);
      if (response?.success) {
        setShowAIInsightsModal(false);
        notification.success({
          message: t("common.aiInsightsTitle"),
          description: t("common.aiInsightsGenerationStarted"),
        });
        const dashId = DashboardId || DashboardReducer?.dashboard?.ID;
        if (dashId) {
          history.push(`/console/top-problems/${dashId}`);
        }
      } else {
        throw new Error("Failed to start generation");
      }
    } catch (error) {
      notification.error({
        message: t("common.aiInsightsGenerationFailed"),
        description: error.message || t("common.aiInsightsGenerationFailedDesc"),
      });
      throw error;
    }
  };

  useEffect(() => {
    if (!showAIInsightsModal || !DashboardId) return;
    const dashId = DashboardId || DashboardReducer?.dashboard?.ID;
    if (!dashId) return;
    const fetchPivots = async () => {
      try {
        const res = await apiRequest(
          "dashboards/root-cause/pivot-options/generation",
          "POST",
          { dashboard_id: parseInt(dashId) },
          true
        );
        if (res?.success && typeof res.success === "object") {
          setGenerationPivotOptions(res.success);
        }
      } catch (e) {
        setGenerationPivotOptions(null);
      }
    };
    fetchPivots();
  }, [showAIInsightsModal, DashboardId, DashboardReducer?.dashboard?.ID]);

  const downloadData = async () => {
    notification.success({
      message: (
        <span>
          {t("notifications.47")}.
          <br />
          Go to{" "}
          <a
            onClick={() => {
              history.push("/console/report?page=download");
            }}
          >
            Exports page
          </a>
        </span>
      ),
    });
    setShowFileTypePopup(false);
    const payload = {
      firebase_id: DashboardReducer.dashboard.UserId,
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      type: fileType,
      user_id: user?.uid,
    };
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      sortByDate,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      fraud,
    } = queryFilters;

    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    applyActiveTopicToPayload(payload, { selected_topic, topics_type });
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    if (fraud) { payload.fraud = fraud; }
    if (onlySequences) { payload.only_sequences = true; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    // No abort signal: the export is queued server-side and the user is
    // sent to the Exports page, so paging or a new search must not cancel it.
    const result = await apiRequest(
      "dashboards/v2/get_download_link",
      "POST",
      payload,
      true
    );
    if (!result?.error && !result?.cancel) {
      trackReviewExported(parseInt(DashboardReducer.dashboard?.ID, 10), fileType);
    }
  };

  const getSearchState = () => {
    if (!selectedTopic?.id) {
      return;
    }
    const {
      chosenKeywords,
      chosenSentiment,
      chosenDate,
      chosenIntent,
      chosenHotTerm,
      chosenDocRating,
    } = DashboardReducer.searchState;
    const payload = {
      topic_id: selectedTopic.id,
      topic_type: topicsType,
    };
    if (chosenKeywords.length !== 0) {
      payload.chosenKeywords = chosenKeywords;
    }
    if (chosenDate) {
      payload.chosenDate = chosenDate;
    }
    if (chosenSentiment) {
      payload.chosenSentiment = chosenSentiment;
    }
    if (chosenIntent) {
      payload.chosenIntent = chosenIntent;
    }
    if (chosenHotTerm) {
      payload.chosenHotTerm = chosenHotTerm;
    }
    if (chosenDocRating) {
      payload.chosenDocRating = chosenDocRating;
    }
    return payload;
  };

  const handleTagSelection = (tag, checked, isFromReviewsSection) => {
    let nextSelectedTags;
    if (isFromReviewsSection === "top_words") {
      nextSelectedTags = checked
        ? [...(queryFilters?.keyword || []), { label: tag, type: "top_words" }]
        : queryFilters?.keyword?.filter((t) => t.label !== tag);
    } else {
      nextSelectedTags = checked
        ? [...(queryFilters?.keyword || []), { label: tag, type: "search" }]
        : queryFilters?.keyword?.filter((t) => t.label !== tag);
    }

    setSelectedTags(nextSelectedTags);
    updateQParams("keyword", JSON.stringify(nextSelectedTags));
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenKeywords: nextSelectedTags,
      },
    });
    if (!isFromReviewsSection && !isFromReviewsSection !== "top_words") {
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: true,
        },
      });
    }
  };
  const restaurantRef = useRef({});
  useEffect(() => {
    for (let i = 0; i >= 0; i++) {
      if (restaurantRef.current && restaurantRef.current[i]) {
        restaurantRef.current[i].current["filtersApplied"] = filters.length > 0;
        restaurantRef.current[i].current.update();
      } else {
        break;
      }
    }
  }, [filters, isRestaurantDoughnutDataLoading, reviewsLoading, restaurantRef]);
  const editTopicLabel = async (e) => {
    e.preventDefault();
    if (newLabel) {
      const payload = {
        topic_id: selectedTopicData.TopicId,
        label: newLabel,
      };
      const result = await apiRequest(
        "dashboards/update/topics",
        "POST",
        payload
      );
      if (result.cancel) {
        notification.error({
          message: t("notifications.82"),
        });
      } else {
        notification.success({
          message: t("notifications.83"),
        });
        let datasets = DashboardReducer.topics.datasets;
        if (DashboardReducer.trends) {
          DashboardReducer.trends.forEach((item, i) => {
            if (item.TopicId === selectedTopic.id) {
              DashboardReducer.trends[i] = { ...item, Label: newLabel };
            }
          });
        }
        if (DashboardReducer.topics) {
          if (DashboardReducer.topics.datasets) {
            DashboardReducer.topics.datasets.forEach((item, i) => {
              if (item.label === selectedTopic.id) {
                if (datasets[i].data) {
                  datasets[i].data[0].name = newLabel;
                }
              }
            });
          }
        }

        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            topics: { datasets },
            loading: false,
          },
        });
        setSelectedTopic({ ...selectedTopic, label: newLabel });
        setNewLabel("");
      }
    } else {
      notification.info({
        message: t("notifications.84"),
        icon: (
          <InfoCircleOutlined
            style={{ color: theme === "dark" ? "white" : "black" }}
          />
        ),
      });
    }
  };

  const handleDoughnutClick = (item, type) => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    if (item) {
      // const datasetIndex = item._datasetIndex;
      const index = item.index;
      if (type === "intent") {
        updateQParams("intent", intentDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenIntent: intentDoughnutData.ids[index],
          },
        });
      } else if (type === "sentiment") {
        updateQParams("sentiment", sentimentDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenSentiment: sentimentDoughnutData.ids[index],
          },
        });
      } else if (type === "rating") {
        updateQParams("rating", ratingDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenDocRating: ratingDoughnutData.ids[index],
          },
        });
      } else if (type === "platform") {
        updateQParams("platform_id", platformData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenPlatformName: platformData.ids[index],
          },
        });
      } else if (type === "fraud") {
        updateQParams("fraud", fraudDoughnutData.ids[index]);
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            chosenFraud: fraudDoughnutData.ids[index],
          },
        });
      }
      dispatch({
        type: actions.UPDATE_Dashboard,
        payload: {
          showNewReviewsLabel: true,
        },
      });
    }
  };

  // const handleDeleteTopic = async () => {
  //   setDeleteLoading(true);
  //   setDisabled(true);
  //   const payload = {
  //     topic_id: selectedTopicData.TopicId,
  //     user_id: user.uid,
  //     dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
  //   };
  //   const result = await apiRequest(
  //     "dashboards/delete/custom_topic",
  //     "POST",
  //     payload,
  //     true
  //   );
  //   setDeleteLoading(false);
  //   if (result.error) {
  //     notification.error({
  //       message: result.error,
  //     });
  //   } else {
  //     notification.success({
  //       message: "Custom topic deleted successfully",
  //     });
  //     window.location.reload(false);
  //     // history.push("/console/myDashboards");
  //   }
  // };

  // const createCustomTopic = async () => {
  //   if (!customTopicState.topic_label) {
  //     notification.error({ message: "Topic Label must be specified" });
  //     return;
  //   }
  //   setDisabled(true);
  //   let url = "dashboards/update/custom_topic";
  //   let payload = {
  //     ...customTopicState,
  //     dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
  //     topic_id: selectedTopicData.TopicId,
  //   };
  //   const result = await apiRequest(url, "POST", payload, true);
  //   if (!result.error) {
  //     notification.success({
  //       message: `Successfully updated custom topic`,
  //     });
  //     dispatch({
  //       type: actions.UPDATE_Dashboard,
  //       payload: {
  //         loadTrends: true
  //       },
  //     });
  //     //history.push("/console/myDashboards");
  //   } else {
  //     notification.error({
  //       message: result.error,
  //     });
  //   }
  //   setState({ ...localState, createCustomTopicModal: false });
  // };

  const colors = [
    "#4400AA",
    "#FF5280",
    "#9E1684",
    "#4582C4",
    "#5C2A70",
    "#D41C1C",
    "#D2B5F2",
    "#56DEC8",
    "#87050D",
    "#836DDE",
    "#FF056D",
    "#BD02FF",
    "#6E6980",
    "#671D9E",
  ];
  const hexToRGBA = (hex, opacity) => {
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };
  const RGBAToHex = (rgba) => {
    const rgbaValues = rgba.match(/\d+/g);
    const r = ("0" + parseInt(rgbaValues[0]).toString(16)).slice(-2);
    const g = ("0" + parseInt(rgbaValues[1]).toString(16)).slice(-2);
    const b = ("0" + parseInt(rgbaValues[2]).toString(16)).slice(-2);
    return `#${r}${g}${b}`;
  };
  const platformIdsANdNamesMap = {
    "1": t("feedback_dropdown_values.14"),
    "2": t("feedback_dropdown_values.15"),
    "4": t("feedback_dropdown_values.17"),
    "5": t("feedback_dropdown_values.18"),
    "6": "Instagram Hashtags",
    "9": t("feedback_dropdown_values.21"),
    "10": t("feedback_dropdown_values.22"),
    "14": t("feedback_dropdown_values.26"),
    "15": t("feedback_dropdown_values.27"),
    "17": t("feedback_dropdown_values.29"),
    "18": t("feedback_dropdown_values.30"),
    "19": t("feedback_dropdown_values.31"),
    "27": t("feedback_dropdown_values.36"),
    "29": t("feedback_dropdown_values.38"),
    "31": t("feedback_dropdown_values.40"),
    "32": t("feedback_dropdown_values.41"),
    "33": t("feedback_dropdown_values.42"),
    "34": t("feedback_dropdown_values.43"),
    "35": t("feedback_dropdown_values.44"),
    "36": "doktortakvimi",
    "30": "Others",
  };

  const intentMapping = {
    "-1": t("feedback_dropdown_values.1"),
    "1": t("feedback_dropdown_values.5"),
    "2": t("feedback_dropdown_values.6"),
    "3": t("feedback_dropdown_values.7"),
    "4": t("feedback_dropdown_values.8"),
    "5": t("feedback_dropdown_values.9"),
    "6": t("feedback_dropdown_values.10"),
    "7": t("feedback_dropdown_values.11"),
    "8": t("feedback_dropdown_values.12"),
    "33": t("feedback_dropdown_values.13"),
  };
  const sentimentMapping = {
    "-1": t("feedback_dropdown_values.1"),
    "0.5": t("feedback_dropdown_values.3"),
    "0.0": t("feedback_dropdown_values.4"),
    "1.0": t("feedback_dropdown_values.2"),
    "33": t("feedback_dropdown_values.13"),
  };
  const intentColors = DASHBOARD_INTENT_COLORS;
  const sentimentColors = {
    "-1": "#FF8C00",
    "0.5": "#FFFF00",
    "0.0": "#DC2525",
    "1.0": "#10C800",
    "33": "#FB6542",
  };
  const platformColors = {
    "1": "#E070EF",
    "2": "#FE4780",
    "4": "#3D85C6",
    "6": "#C018D6",
    "9": "#C018D6",
    "10": "#C018D6",
    "14": "#1B031F",
    "17": "#891199",
    "5": "#652CB3",
    "18": "#D896FF",
    "19": "#800080",
    "27": "#962FBF",
    "29": "#000000",
    "31": "#800AF0",
    "32": "#891199",
    "33": "#C018D6",
    "34": "#1B031F",
    "35": "#891199",
    "30": "#FF6B35",
  };
  const initIntentDoughnutData = async (intent_percent_obj) => {
    if (intent_percent_obj && Object.keys(intent_percent_obj).length > 0) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];

      Object.keys(intent_percent_obj).map((key) => {
        if (intent_percent_obj[key] > 1) {
          datas.push(intent_percent_obj[key]);
          labels.push(intentMapping[key]);
          backgroundColors.push(hexToRGBA(intentColors[key], 0.8));
          hoverBackgroundColors.push(hexToRGBA(intentColors[key], 0.5));
        }
      });
      const intentDoughnutData = {
        maintainAspectRatio: false,
        responsive: true,
        text: "intent",
        labels: labels,
        ids: Object.keys(intent_percent_obj).filter(
          (key) => intent_percent_obj[key] > 1
        ),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };
      setIntentDoughnutData(intentDoughnutData);
    }
  };
  const [restaurantColorMap, setRestaurantColorMap] = useState({});
  const initRestaurantDoughnutData = async (filteredData, actualData) => {
    if (
      filteredData &&
      Object.keys(filteredData)?.length > 0 &&
      actualData &&
      Object.keys(actualData)?.length > 0
    ) {
      let doughnutDataArray = Object.keys(filteredData).map((key) => {
        const restaurant_obj = filteredData[key];
        const act_obj = actualData[key];
        if (restaurant_obj) {
          const restaurant_arr = [];
          const act_arr = [];
          let total = 0;
          const counts = [];
          Object.keys(restaurant_obj).map((key) => {
            const value = restaurant_obj[key];
            total += showNormalizedData ? value.percentage : value.count;
            restaurant_arr.push([key, value]);
          });
          restaurant_arr.sort(function(a, b) {
            return showNormalizedData
              ? b[1].percentage - a[1].percentage
              : b[1].count - a[1].count;
          });
          const data = [];
          const act_data = [];
          const act_counts = [];
          const labels = [];
          const backgroundColor = [];
          const hoverBackgroundColor = [];
          const threshold = 7;
          const k = Math.min(threshold, restaurant_arr.length);
          const totalCount = restaurant_arr.reduce((acc, curr) => {
            return acc + curr[1].count;
          }, 0);
          let x = 0;
          let y = 0;
          for (let i = 0; i < k; i++) {
            let color = "";
            if (i === k - 1 && k === threshold) {
              if (restaurantColorMap["Others"]) {
                color = restaurantColorMap["Others"];
              } else {
                color = colors[i % colors.length];
                setRestaurantColorMap((prev) => {
                  return { ...prev, ["Others"]: color };
                });
              }
              backgroundColor.push(hexToRGBA(color, 1.0));
              hoverBackgroundColor.push(hexToRGBA(color, 0.6));
              data.push(showNormalizedData ? 100 - x : totalCount - y);
              labels.push("Others");
              counts.push(totalCount - y);
            } else {
              const label = restaurant_arr[i][0];
              if (restaurantColorMap[label]) {
                color = restaurantColorMap[label];
              } else {
                color = colors[i % colors.length];
                setRestaurantColorMap((prev) => {
                  return { ...prev, [label]: color };
                });
              }
              backgroundColor.push(hexToRGBA(color, 1.0));
              hoverBackgroundColor.push(hexToRGBA(color, 0.6));
              x += showNormalizedData ? restaurant_arr[i][1].percentage : 0;
              y += restaurant_arr[i][1].count;
              data.push(
                showNormalizedData
                  ? restaurant_arr[i][1].percentage
                  : restaurant_arr[i][1].count
              );
              labels.push(label);
              counts.push(restaurant_arr[i][1].count);
            }
          }
          let abc = 0;
          let xyz = 0;
          labels.map((label, i) => {
            const totalActualCount = Object.values(act_obj).reduce(
              (total, curr) => total + curr.count,
              0
            );
            if (i === 6 && label === "Others") {
              act_counts.push(totalActualCount - xyz);
              act_data.push(
                showNormalizedData ? 100 - abc : totalActualCount - xyz
              );
            } else {
              // Add safety check for act_obj[label]
              if (act_obj[label]) {
                abc += showNormalizedData ? act_obj[label].percentage : 0;
                xyz += act_obj[label].count;
                act_data.push(
                  showNormalizedData
                    ? act_obj[label].percentage
                    : act_obj[label].count
                );
                act_counts.push(act_obj[label].count);
              } else {
                // Handle missing label in act_obj
                act_data.push(0);
                act_counts.push(0);
              }
            }
          });
          const doughnutData = {
            datasets: [
              {
                backgroundColor: backgroundColor,
                data: data,
                actualData: act_data,
                actualCounts: act_counts,
                hoverBackgroundColor: hoverBackgroundColor,
                counts: counts,
              },
            ],
            labels: labels,
            maintainAspectRatio: false,
            responsive: true,
            text: "restaurant",
            doughnutLabel: key,
          };
          return doughnutData;
        }
      });
      setRestaurantDoughnutData(doughnutDataArray);
    }
  };
  const initDecisionChartsData = (data) => {
    if (data?.length > 0) {
      const dataArr = data.map((decision) => {
        const labels =
          decision.decision === "publish"
            ? ["Do not Publish", "Publish"]
            : decision.decision === "opencase"
              ? ["Do not open case", "Open case"]
              : ["Do not take action", "Take action"];
        const distribution = decision.dist;
        if (distribution.True + distribution.False === 0) {
          return {
            labels,
            datasets: [
              {
                data: [0, 0],
                counts: [0, 0],
              },
            ],
            doughnutLabel: decision.decision,
          };
        }
        const truePerc =
          (distribution.True / (distribution.True + distribution.False)) * 100;
        const falsePerc =
          (distribution.False / (distribution.True + distribution.False)) * 100;
        const datasets = [
          {
            data: [falsePerc.toFixed(1), truePerc.toFixed(1)],
            backgroundColor:
              decision.decision === "publish"
                ? [hexToRGBA("#3A6D8C", 1), hexToRGBA("#41B3A2", 1)]
                : decision.decision === "opencase"
                  ? [hexToRGBA("#D91656", 1), hexToRGBA("704264", 1)]
                  : [hexToRGBA("#304463", 1), hexToRGBA("#758694", 1)],
            hoverBackgroundColor:
              decision.decision === "publish"
                ? [hexToRGBA("#3A6D8C", 0.8), hexToRGBA("#41B3A2", 0.8)]
                : decision.decision === "opencase"
                  ? [hexToRGBA("#D91656", 0.8), hexToRGBA("#704264", 0.8)]
                  : [hexToRGBA("#304463", 0.8), hexToRGBA("#758694", 0.8)],
            counts: [distribution.False, distribution.True],
          },
        ];
        return {
          labels,
          datasets,
          text: "decision",
          doughnutLabel: decision.decision,
        };
      });
      const sumOfDataValues = dataArr.map((item) =>
        item.datasets[0].data.reduce((acc, curr) => acc + parseInt(curr), 0)
      );
      if (sumOfDataValues.every((sum) => sum === 0)) {
        setDecisionData([]);
      } else {
        setDecisionData(dataArr);
      }
    } else {
      setDecisionData([]);
    }
  };

  const initPlatformDoughnutData = (platform_obj = {}) => {
    const datas = [];
    const labels = [];
    const backgroundColors = [];
    const hoverBackgroundColors = [];
    Object.keys(platform_obj).map((key) => {
      if (platform_obj[key] > 1) {
        datas.push(platform_obj[key]);
        labels.push(platformIdsANdNamesMap[key]);
        backgroundColors.push(hexToRGBA(platformColors[key], 0.8));
        hoverBackgroundColors.push(hexToRGBA(platformColors[key], 0.5));
      }
    });
    const platformData = {
      maintainAspectRatio: false,
      responsive: true,
      text: "Platform",
      labels: labels,
      ids: Object.keys(platform_obj).filter((key) => platform_obj[key] > 1),
      datasets: [
        {
          data: datas,
          backgroundColor: backgroundColors,
          hoverBackgroundColor: hoverBackgroundColors,
        },
      ],
    };
    setPlatformData(platformData);
  };

  const determinePeriod = (val) => {
    try {
      let identifier = (val.match(/-/g) || []).length;
      return identifier === 0
        ? "Yearly"
        : identifier === 1
          ? "Monthly"
          : "Daily";
    } catch (e) {
      console.log("Error", e);
      return "Monthly";
    }
  };

  const handleTimePeriodOptions = (val, flag) => {
    setParticipationPeriod(val);
    setSentimentPeriod(val);
    setratingPeriodLoading(true);
    setratingsPeriod(val);
    setSwitchPeriod(val);
  };

  const timePeriodOptions = (flag) => {
    const itemStyle = {
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff",
    };
    return (
      <Menu
        style={{ backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff" }}
        onClick={(e) => handleTimePeriodOptions(e.key, flag)}
      >
        <Menu.Item key="Daily" style={itemStyle}>
          {t("selected_dashboard_page.1")}
        </Menu.Item>
        {/* <Menu.Item key="Weekly" style={itemStyle}>
          Weekly
        </Menu.Item> */}
        <Menu.Item key="Monthly" style={itemStyle}>
          {t("selected_dashboard_page.2")}
        </Menu.Item>
        <Menu.Item key="Yearly" style={itemStyle}>
          {t("selected_dashboard_page.3")}
        </Menu.Item>
      </Menu>
    );
  };
  const handleResetTopicFilters = () => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    for (let l = 1; l >= 1; l++) {
      if (params.has(`level${l}Selection`)) {
        params.delete(`level${l}Selection`);
        history.push({ search: params.toString() });
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            [`selectedL${l}Topic`]: null,
          },
        });
      } else {
        break;
      }
    }
  };
  const handleResetFilter = () => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    handleResetTopicFilters();
    handleResetPivotFilters();
    handleClearAllTopTopics();
    [
      "sentiment",
      "intent",
      "since",
      "until",
      "daysRange",
      "rating",
      "top_topics",
      "topics_operator",
      "platform_id",
      "match_date",
      "hotterm",
      "nps",
      "keyword",
      "pivotFilter",
      "pivots_operator",
      "decisionFilter",
      "cursor_next",
      "cursor_curr",
      "cursor_before",
      "savedSearchID",
      "child_others",
      "parent_others",
      "fraud",
    ].forEach((item) => params.delete(item));
    params.append("daysRange", "allTime");
    history.push({ search: params.toString() });
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenKeywords: [],
        chosenSentiment: "",
        chosenDate: "",
        chosenFetchType: "topic",
        sortByDate: false,
        chosenIntent: "",
        chosenHotTerm: "",
        chosenDocRating: "",
        showNewReviewsLabel: false,
        chosenRestaurantName: "",
        chosenPlatformName: "",
        chosenTopTopic: [],
        topicsOperator: "AND",
        chosenNPS: "",
        dateRange: [],
        pivotFilter: {},
        pivots_operator: null,
        selectedL1Topic: "",
        selectedL2Topic: "",
        level1OfSelectedTopic: "",
        level2OfSelectedTopic: "",
        chosenFraud: "",
      },
    });
    dispatch({
      type: actions.SELECT_TOPIC,
      payload: {
        selected_topic: undefined,
        insightBasedSearch: {},
        trends: {},
      },
    });
  };

  const handleCopyRule = (rule) => {
    copyToClipboard(rule);
    notification.success({
      message: t("notifications.31"),
    });
  };

  const handleNPSFilter = (label) => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    updateQParams("nps", label);
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: {
        chosenNPS: label,
      },
    });
  };

  const handleShowFileType = () => {
    setShowFileTypePopup(true);
  };

  useEffect(() => {
    if (
      selectedTopicFromBars &&
      Object.keys(selectedTopicFromBars).length > 0
    ) {
      Object.keys(selectedTopicFromBars).forEach((key) => {
        const item = selectedTopicFromBars[key];
        if (item?.id) {
          updateQParams(`level${item.level}Selection`, JSON.stringify(item));
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              [`selectedL${item.level}Topic`]: item.id,
            },
          });
        }
      });
    }
  }, [selectedTopicFromBars]);

  useEffect(() => {
    if (
      params.has("level1Selection") &&
      ((topicRatingData &&
        topicRatingData.length > 0 &&
        !topicRatingData
          .map((t) => t?.rating?.value)
          .every((t) => parseInt(t, 10) === 0)) ||
        (topicSentimentData && topicSentimentData.length > 0))
    ) {
      for (let l = 1; l >= 1; l++) {
        if (params.has(`level${l}Selection`)) {
          const levelSelection = JSON.parse(params.get(`level${l}Selection`));
          setSelectedTopicFromBars((prev) => {
            return {
              ...prev,
              [levelSelection?.id]: levelSelection,
            };
          });
          dispatch({
            type: actions.UPDATE_SEARCH_STATE,
            payload: {
              [`selectedL${l}Topic`]: levelSelection?.id,
            },
          });
        } else {
          break;
        }
      }
    }
  }, [topicRatingData]);

  useEffect(() => {
    if (pivotOptions) {
      const options = {
        level1: [],
        level2: {},
      };

      Object.keys(pivotOptions).forEach((key) => {
        // Level 1 options
        options.level1.push({
          id: key?.toString(),
          label: key?.toString(),
          value: key?.toString(),
        });

        // Construct level2 options
        options.level2[key] = pivotOptions[key].map((option) => ({
          id: option?.toString(),
          label: option?.toString(),
          value: option?.toString(),
        }));
      });
      setMultiLevelOptions(options);
    }
  }, [pivotOptions]);
  const handlePivotDoughnutClick = (key, value) => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    const pvtFilter = params.get("pivotFilter")
      ? JSON.parse(params.get("pivotFilter"))
      : {};
    if (
      pvtFilter &&
      Object.keys(pvtFilter).length > 0 &&
      Object.values(pvtFilter).flat().length > 0
    ) {
      if (Object.keys(pvtFilter).includes(key)) {
        return;
      }
      setSelectedPivots((prevSeletedPivots) => {
        updateQParams(
          "pivotFilter",
          JSON.stringify({ ...prevSeletedPivots, [key]: [value] })
        );
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            pivotFilter: { ...prevSeletedPivots, [key]: [value] },
          },
        });
        return { ...prevSeletedPivots, [key]: [value] };
      });
      setLevelWisePivotSelections((prev) => ({
        ...prev,
        [key]: { ...prev[key], [value]: {} },
      }));
    } else {
      updateQParams("pivotFilter", JSON.stringify({ [key]: [value] }));
      setSelectedPivots({ [key]: [value] });
      setLevelWisePivotSelections({
        [key]: { [value]: {} },
      });
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: {
          pivotFilter: { [key]: [value] },
        },
      });
    }
  };

  const handleDecisionDoughnutClick = (key, value) => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    const decFilter = params.get("decisionFilter")
      ? JSON.parse(params.get("decisionFilter"))
      : {};
    if (
      decFilter &&
      Object.keys(decFilter).length > 0 &&
      Object.values(decFilter).flat().length > 0
    ) {
      if (Object.keys(decFilter).includes(key)) {
        return;
      }
      setSelectedDecisions((prevSelectedDecisions) => {
        updateQParams(
          "decisionFilter",
          JSON.stringify({ ...prevSelectedDecisions, [key]: value })
        );
        dispatch({
          type: actions.UPDATE_SEARCH_STATE,
          payload: {
            decisionFilter: { ...prevSelectedDecisions, [key]: value },
          },
        });
        return { ...prevSelectedDecisions, [key]: value };
      });
    } else {
      updateQParams("decisionFilter", JSON.stringify({ [key]: value }));
      setSelectedDecisions({ [key]: value });
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: {
          decisionFilter: { [key]: value },
        },
      });
    }
  };

  const getSelectedPivotsFromLevelWisePivotSelections = (
    levelWisePivotSelections,
    multiLevelOptions
  ) => {
    const level1Map = multiLevelOptions.level1.reduce((acc, item) => {
      acc[item.id] = item.label;
      return acc;
    }, {});

    const level2Map = Object.keys(multiLevelOptions.level2).reduce(
      (acc, level1Id) => {
        acc[level1Id] = multiLevelOptions.level2[level1Id].reduce(
          (subAcc, item) => {
            subAcc[item.id] = item.label;
            return subAcc;
          },
          {}
        );
        return acc;
      },
      {}
    );

    const requiredFormat = Object.keys(levelWisePivotSelections).reduce(
      (acc, level1Id) => {
        const level1Label = level1Map[level1Id];
        if (level1Label) {
          acc[level1Label] = Object.keys(
            levelWisePivotSelections[level1Id]
          ).map((level2Id) => level2Map[level1Id][level2Id]);
        }
        return acc;
      },
      {}
    );
    return requiredFormat;
  };

  useEffect(() => {
    if (
      levelWisePivotSelections &&
      Object.keys(levelWisePivotSelections).length > 0 &&
      multiLevelOptions &&
      Object.keys(multiLevelOptions?.level1)?.length > 0
    ) {
      const selectedPvts = getSelectedPivotsFromLevelWisePivotSelections(
        levelWisePivotSelections,
        multiLevelOptions
      );
      if (selectedPvts && Object.keys(selectedPvts).length > 0) {
        setSelectedPivots(selectedPvts);
      }
    }
  }, [levelWisePivotSelections]);

  const handleApplyPivotFilters = (operator = "AND") => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    if (selectedPivots) {
      updateQParams("pivotFilter", JSON.stringify(selectedPivots));
      updateQParams("pivots_operator", operator);
      dispatch({
        type: actions.UPDATE_SEARCH_STATE,
        payload: { pivotFilter: selectedPivots, pivots_operator: operator },
      });
    }
  };

  const handleResetPivotFilters = () => {
    // if (
    //   reviewsLoading ||
    //   topTopicsLoading ||
    //   participationPeriodLoading ||
    //   topicRatingsLoading ||
    //   hottermsLoading ||
    //   decisionDataLoading ||
    //   isIntentDoughnutDataLoading ||
    //   isRatingDoughnutDataLoading ||
    //   isSentimentDoughnutDataLoading ||
    //   isAvgSentimentGaugeDataLoading ||
    //   isPlatformDoughnutDataLoading ||
    //   isRestaurantDoughnutDataLoading
    // ) {
    //   return;
    // }
    params.delete("pivotFilter");
    params.delete("pivots_operator");
    history.push({ search: params.toString() });
    dispatch({
      type: actions.UPDATE_SEARCH_STATE,
      payload: { pivotFilter: {}, pivots_operator: null },
    });
    setSelectedPivots({});
    setLevelWisePivotSelections({});
  };

  useEffect(() => {
    if (
      params.get("pivotFilter") &&
      multiLevelOptions &&
      Object.keys(multiLevelOptions).length > 0
    ) {
      const pvtFilters = Object.entries(
        JSON.parse(params.get("pivotFilter"))
      ).flatMap(([key, values]) => {
        return values.map((value) => ({ key: key, value: value }));
      });
      if (pvtFilters && pvtFilters.length > 0) {
        pvtFilters.map((filter) => {
          setLevelWisePivotSelections((prev) => ({
            ...prev,
            [filter.key]: { ...prev[filter.key], [filter.value]: {} },
          }));
        });
      }
    }
  }, [multiLevelOptions]);

  const removeParentFromChildren = (parent) => {
    if (parent && parent !== "" && parent.includes(">")) {
      const substrs = parent.split(">").slice(-1)[0];
      return substrs;
    } else {
      return parent;
    }
  };

  const roundSentiments = (sentiment) => {
    const keys = Object.keys(sentiment);

    // Round values and calculate new total
    let roundedSentiment = {};
    let roundedTotal = 0;
    keys.forEach((key) => {
      const roundedPercentage = Math.round(sentiment[key].percentage * 10) / 10;
      roundedSentiment[key] = {
        ...sentiment[key],
        percentage: roundedPercentage,
      };
      roundedTotal += roundedPercentage;
    });

    // Adjust if the total exceeds 100
    if (roundedTotal > 100) {
      let maxKey = keys[0];
      keys.forEach((key) => {
        if (
          roundedSentiment[key].percentage > roundedSentiment[maxKey].percentage
        ) {
          maxKey = key;
        }
      });
      const excess = roundedTotal - 100;
      roundedSentiment[maxKey].percentage -= excess + 0.1;
      roundedTotal -= excess;
    }

    return roundedSentiment;
  };

  const adjustSentiments = (data) => {
    return data.map((item) => {
      if (item.sentiment) {
        item.sentiment = roundSentiments(item.sentiment);
      }
      if (item.child && item.child.length > 0) {
        item.child = adjustSentiments(item.child);
      }
      return item;
    });
  };

  const formatCountsForDoughnuts = (count) => {
    if (count >= 1000000) {
      return (count / 1000000).toFixed(1) + "M";
    } else if (count >= 1000) {
      return (count / 1000).toFixed(1) + "K";
    } else {
      return count;
    }
  };
  const hasAlphabet = (str) => {
    return /[A-Za-z]/.test(str);
  };

  const getDecisionData = async () => {
    const {
      sentiment,
      intent,
      since,
      until,
      rating,
      top_topics,
      topics_operator,
      platform_id,
      match_date,
      hotterm,
      nps,
      keyword,
      pivotFilter,
      pivots_operator,
      topics_type,
      selected_topic,
      decisionFilter,
      child_others,
      parent_others,
      sortByDate,
      fraud,
    } = queryFilters;
    const payload = {
      dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10),
      start_index: 0,
      num_docs: numOfDocs,
      user_id: user?.uid,
    };
    if (since && until) {
      payload.since = since;
      payload.until = until;
    }
    if (sentiment) {
      payload.sentiment = sentiment;
    }
    if (intent) {
      payload.intent = intent;
    }
    if (rating) {
      payload.rating = rating;
    }
    if (hotterm?.term) {
      payload.hotterm = [hotterm.term, ...hotterm.similarTerms];
    }
    if (keyword && keyword.length > 0) {
      payload.keyword = keyword;
    }
    if (match_date) {
      payload.match_date = match_date;
    }
    if (platform_id) {
      payload.platform_id = platform_id;
    }
    if (nps) {
      payload.nps = nps;
    }
    if (
      pivotFilter &&
      Object.keys(pivotFilter).length > 0 &&
      Object.values(pivotFilter)?.flat().length > 0
    ) {
      payload.pivotFilter = pivotFilter;
      payload.pivots_operator = pivots_operator;
    }
    if (decisionFilter && Object.keys(decisionFilter)?.length > 0) {
      payload.decisionFilter = decisionFilter;
    }
    applyActiveTopicToPayload(payload, { selected_topic, topics_type });
    if (top_topics && top_topics.length > 0) {
      payload.top_topics = top_topics;
      payload.topics_operator = topics_operator ? topics_operator : "AND";
      if (child_others?.length > 0) {
        payload.top_topics_others = true;
        payload.child_others = child_others;
      } else if (parent_others?.length > 0) {
        payload.top_topics_others = true;
        payload.parent_others = parent_others;
      } else {
        payload.top_topics_others = false;
      }
    }
    if (switchPeriod) {
      payload.volume_period = switchPeriod.toLowerCase();
      payload.sentiment_period = switchPeriod.toLowerCase();
      payload.ratings_period = switchPeriod.toLowerCase();
    } else {
      payload.volume_period = dateBasedChartsPeriod.toLowerCase();
      payload.sentiment_period = dateBasedChartsPeriod.toLowerCase();
      payload.ratings_period = dateBasedChartsPeriod.toLowerCase();
    }
    // if (sortByDate) payload.sortByDate = true;
    if (fraud) { payload.fraud = fraud; }
    const selectedTpcs = {};
    for (let level = 1; level >= 1; level++) {
      if (params.has(`level${level}Selection`)) {
        const levelSelection = JSON.parse(params.get(`level${level}Selection`));
        selectedTpcs[level] = levelSelection;
      } else {
        break;
      }
    }

    const maxLevel = Math.max(...Object.keys(selectedTpcs));
    if (maxLevel > 0) {
      payload.topic_id = selectedTpcs[maxLevel]?.id;
    }
    const result = await apiRequest(
      "dashboards/decision_distribution",
      "POST",
      payload,
      true,
      widgetsControllerRef.current?.signal
    );
    if (isAbortedResult(result)) return;
    if (result?.success) {
      initDecisionChartsData(result?.success);
    } else if (isReviewRangeTooLarge(result)) {
      notifyReviewRangeTooLarge(result, t);
    } else {
      notification.error({
        message: result?.error
          ? result.error
          : "Failed to get decision analysis data",
      });
    }
    setDecisionDataLoading(false);
  };
  const basicDoughnutOptions = {
      responsive: true,
      maintainAspectRatio: false,
      cutout: "65%",
      onHover: (event, chartElement) => {
        if (chartElement.length) {
          event.native.target.style.cursor = "pointer";
        } else {
          event.native.target.style.cursor = "default";
        }
      },
      plugins: {
        legend: {
          display: true,
          position: "right",
          labels: {
            usePointStyle: true,
            color: theme === "dark" ? "white" : "black",
            font: {
              size: 12,
              color: theme === "dark" ? "white" : "black",
            },
            pointStyle: "circle",
            pointStyleWidth: 16,
            padding: 20,
            boxWidth: 12,
          },
          onHover: (event, chartElement) => {
            if (chartElement) {
              event.native.target.style.cursor = "pointer";
            } else {
              event.native.target.style.cursor = "default";
            }
          },
        },
        tooltip: {
          enabled: false,
          external: (context) => {
            // Tooltip Element
            var tooltipEl = document.getElementById("chartjs-tooltip");
  
            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chartjs-tooltip";
              tooltipEl.innerHTML = "<div></div>";
              document.body.appendChild(tooltipEl);
            }
  
            // Hide if no tooltip
            const tooltipModel = context.tooltip;
            if (tooltipModel.opacity === 0) {
              if (tooltipEl) {
                tooltipEl.remove();
              }
              return;
            }
            // Set caret Position
            tooltipEl.classList.remove("above", "below", "no-transform");
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add("no-transform");
            }
  
            function getBody(bodyItem) {
              return bodyItem.lines;
            }
  
            // Set Text
            if (tooltipModel.body) {
              let innerHtml = "<div class=" + styles.driversTooltip + ">";
              const index = tooltipModel.dataPoints[0].dataIndex;
              const dataset = tooltipModel.dataPoints[0].dataset;
              const datasetLabel = tooltipModel.dataPoints[0].label;
              const datasetValue = tooltipModel.dataPoints[0].raw;
              innerHtml += `
              <div class=${styles.topicLabelInTooltip}>
                <span class=${styles.fillColor} style="background-color: ${dataset?.backgroundColor[index]}"></span>
                <span class=${styles.topicLabel}>${datasetLabel}: ${datasetValue}%</span>
              </div>`;
              innerHtml += "</div>";
              const tooltipRoot = tooltipEl.querySelector("div");
              tooltipRoot.innerHTML = innerHtml;
            }
            // this will be the overall tooltip
            const position = context.chart.canvas.getBoundingClientRect();
  
            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.position = "absolute";
            let left = position.left + window.pageXOffset + tooltipModel.caretX;
            if (left + tooltipEl.offsetWidth > window.innerWidth) {
              left =
                position.left +
                window.pageXOffset / 2 +
                tooltipModel.caretX -
                tooltipEl.offsetWidth;
            }
            tooltipEl.style.left = left + "px";
            tooltipEl.style.top =
              position.top + window.pageYOffset + tooltipModel.caretY + "px";
            tooltipEl.style.padding =
              tooltipModel.padding + "px " + tooltipModel.padding + "px";
            tooltipEl.style.pointerEvents = "none";
          },
        },
        datalabels: {
          display: true,
          color: "white",
          font: {
            size: 9,
          },
          formatter: (value, context) => {
            // Hide labels for NaN or extremely small values (less than 0.1%)
            if (isNaN(value) || value < 1) {
              return "";
            }
            // Show whole numbers for larger values
            return Math.round(value) + "%";
          },
        },
      },
      elements: {
        arc: {
          borderWidth: 0,
        },
      },
    };
  const handleDownloadChartData = async (data, type) => {
    if (type === "Sentiment") {
      setDownloadSentimentChartsDataLoading(true);
    } else {
      setDownloadRatingChartsDataLoading(true);
    }
    const processData = (topics, type) => {
      let rows = [];
      let serialNumber = 1;

      const processTopics = (topics) => {
        topics.forEach((topic) => {
          if (type === "Sentiment") {
            const positive = topic.sentiment["1.0"];
            const negative = topic.sentiment["0.0"];
            const neutral = topic.sentiment["0.5"];
            const unspecified = topic.sentiment["-1"];

            rows.push({
              "S.No": serialNumber++,
              TopicId: topic.id,
              Label: topic.label,
              "Positive %": positive.percentage,
              "Positive Count": positive.value,
              "Negative %": negative.percentage,
              "Negative Count": negative.value,
              "Neutral %": neutral.percentage,
              "Neutral Count": neutral.value,
              "Unspecified %": unspecified.percentage,
              "Unspecified Count": unspecified.value,
              "Contribution to Rating": topic.potential || 0,
            });
          } else if (type === "Rating") {
            rows.push({
              "S.No": serialNumber++,
              TopicId: topic.id,
              Label: topic.label,
              "Avg. Rating": topic.rating.value,
              "Reviews Count": topic.rating.reviewsCount,
              "Contribution to Rating": topic.potential || 0,
            });
          }

          // Process child topics
          if (topic.child && topic.child.length > 0) {
            processTopics(topic.child);
          }
        });
      };

      processTopics(topics);
      return rows;
    };

    // Flatten and process the data
    const drows = processData(data, type);

    const headers =
      type === "Sentiment"
        ? [
          [
            "S.No",
            "TopicId",
            "Label",
            "Positive",
            null,
            "Negative",
            null,
            "Neutral",
            null,
            "Unspecified",
            null,
            "Contribution to Rating",
          ],
          [
            "",
            "",
            "",
            "%",
            "Count",
            "%",
            "Count",
            "%",
            "Count",
            "%",
            "Count",
            "",
          ],
        ]
        : [["S.No", "TopicId", "Label", "Avg. Rating", "Reviews Count", "Contribution to Rating"]];

    const dataRows = drows?.map((row) =>
      type === "Sentiment"
        ? [
          row["S.No"],
          row.TopicId,
          row.Label,
          row["Positive %"],
          row["Positive Count"],
          row["Negative %"],
          row["Negative Count"],
          row["Neutral %"],
          row["Neutral Count"],
          row["Unspecified %"],
          row["Unspecified Count"],
          row["Contribution to Rating"],
        ]
        : [
          row["S.No"],
          row.TopicId,
          row.Label,
          row["Avg. Rating"],
          row["Reviews Count"],
          row["Contribution to Rating"],
        ]
    );

    // Combine headers and data
    const worksheetData = [...headers, ...dataRows];

    const since = params.get("since");
    const until = params.get("until");
    const fileName =
      since && until
        ? `${type}_chartdata_${since}_${until}.xlsx`
        : `${type}_chartdata_alltime.xlsx`;

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Topics");

    // Merge headers
    if (type === "Sentiment") {
      worksheet["!merges"] = [
        { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }, // Merges cells at (0,3) and (0,4)
        { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } }, // Merges cells at (0,5) and (0,6)
        { s: { r: 0, c: 7 }, e: { r: 0, c: 8 } }, // Merges cells at (0,7) and (0,8)
        { s: { r: 0, c: 9 }, e: { r: 0, c: 10 } }, // Merges cells at (0,9) and (0,10)
      ];
    }

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const fileBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    const response = await apiRequest(
      "dashboards/presigned_post",
      "POST",
      {
        filename: fileName,
      },
      true
    );
    if (response?.success) {
      const fileUrl = response.success;
      const result = await uploadFileToS3(
        fileUrl,
        fileBlob,
        setChartDataDownloadProgress
      );
      if (result) {
        const presignedUrl = await apiRequest("dashboards/store", "POST", {
          key: fileUrl?.fields?.key,
          dashboard_id: parseInt(initialState.currentDashboard, 10),
          type: type,
        });
        if (presignedUrl?.success) {
          notification.success({
            message: (
              <span>
                {t("notifications.47")}.
                <br />
                Go to{" "}
                <a
                  onClick={() => {
                    history.push("/console/report?page=download");
                  }}
                >
                  Exports page
                </a>
              </span>
            ),
          });
        } else {
          notification.error({
            message: t("notifications.73"),
          });
        }
      } else {
        notification.error({
          message: t("notifications.73"),
        });
      }
    } else {
      notification.error({
        message: t("notifications.73"),
      });
    }
    setDownloadSentimentChartsDataLoading(false);
    setDownloadRatingChartsDataLoading(false);
  };


  // Delete Topic Handler
  const handleDeleteTopic = async () => {
    setDeleteLoading(true);
    const payload = {type:1,all: false, topic_ids: [selectedTopicData.TopicId],dashboard_id: parseInt(DashboardReducer.dashboard?.ID, 10)};
    const result = await apiRequest(
      "dashboards/v2/delete/custom_topic",
      "POST",
      payload,
      true
    );
    setDeleteLoading(false);
    if (result?.success) {
      notification.success({ message: t("notifications.29") });
      setDeleteModalOpen(false);
      // Close deep dive and refresh data
      if (closeSelectedTopic) closeSelectedTopic();
      if (setTopicChanged) setTopicChanged(true);
      // window.location.reload(false); // Removed for smooth refresh
    } else {
      notification.error({ message: result?.error || t("notifications.73") });
      setDeleteModalOpen(false);
    }
  };

  // Helper to convert topics to Ant Design TreeSelect format, filtering out 'Others' and type 1 (AI topics)
  const buildTreeSelectData = (topics) => {
    return (topics || [])
      .filter(topic => topic?.name?.toLowerCase() !== 'others' && topic?.label?.toLowerCase() !== 'others' && topic.type !== 1)
      .map(topic => ({
        value: topic.id,
        title: topic.name || topic.label,
        children: topic.child && topic.child.length > 0 ? buildTreeSelectData(topic.child) : undefined,
        disabled: topic.id === selectedTopicData?.TopicId // Prevent selecting self as parent
      }));
  };

  const fetchParentOptions = async () => {
    if (topTopicsLoading) {
      setParentOptionsLoading(true);
      setParentOptions([]);
      return;
    }
    setParentOptionsLoading(true);
    setRepositionError("");
    try {
      const topTopicsTree = (topTopics && topTopics.tree) ? topTopics.tree : [];
      // Filter out 'Others' and type 1 topics recursively
      const treeData = buildTreeSelectData(topTopicsTree);
      setParentOptions(treeData);
      if (selectedTopicData?.parent_id) {
        setSelectedParent(selectedTopicData.parent_id);
      } else {
        setSelectedParent("none");
      }
    } catch (e) {
      setRepositionError(t("notifications.73"));
    }
    setParentOptionsLoading(false);
  };

  // Reposition Topic Handler
  const handleRepositionTopic = async () => {
    if (selectedParent === null) return;
    setRepositionLoading(true);
    setRepositionError("");
    const payload = {
      child_id: selectedTopicData.TopicId,
      parent_id: selectedParent === "none" ? null : selectedParent
    };
    const result = await apiRequest("dashboards/topics/reposition", "POST", payload, true);
    setRepositionLoading(false);
    if (result?.success) {
      notification.success({ message: t("Topic repositioned successfully") });
      setRepositionModalOpen(false);
      if (closeSelectedTopic) closeSelectedTopic();
      if (setTopicChanged) setTopicChanged(true);
    } else {
      setRepositionError(result?.error || t("notifications.73"));
    }
  };

  // Inline rename handlers
  const handleRenameClick = () => { setIsEditing(true); };
  const handleRenameChange = (e) => {
    setRenameValue(e.target.value);
    setCharCount(e.target.value.length);
    setRenameError("");
  };
  const handleRename = async () => {
    const trimmedValue = renameValue.trim();
    
    // Validation
    if (trimmedValue === "" || trimmedValue.length < minLen || trimmedValue.length > maxLen) {
      setRenameError(`Name must be ${minLen}-${maxLen} characters.`);
      return;
    }
    
    if (trimmedValue === selectedTopic?.label) {
      setIsEditing(false);
      return;
    }
    
    setRenameLoading(true);
    setRenameError(""); // Clear previous error
    
    try {
      // API call
      const payload = { topic_id: selectedTopicData.TopicId, label: trimmedValue };
      const result = await apiRequest("dashboards/update/topics", "POST", payload, true);
      
      console.log("result ", result);
      
      if (result?.success) {
        // Create deep copy to avoid direct mutation
        const updatedState = { ...DashboardReducer };
        
        // Update trends if exists and is array
        if (updatedState.trends && Array.isArray(updatedState.trends)) {
          updatedState.trends = updatedState.trends.map(item => 
            item.TopicId === selectedTopic.id 
              ? { ...item, Label: trimmedValue }
              : item
          );
        }
        
        // Update topics datasets if exists and is array
        if (updatedState.topics?.datasets && Array.isArray(updatedState.topics.datasets)) {
          updatedState.topics.datasets = updatedState.topics.datasets.map(item => {
            if (item.label === selectedTopic.id) {
              return {
                ...item,
                data: item.data && Array.isArray(item.data) && item.data.length > 0 ? [{
                  ...item.data[0],
                  name: trimmedValue
                }, ...item.data.slice(1)] : item.data
              };
            }
            return item;
          });
        }
        
        // Dispatch the complete updated state
        dispatch({
          type: actions.UPDATE_Dashboard,
          payload: {
            ...updatedState,
            loading: false,
          },
        });
        
        // Update local state
        setSelectedTopic({ ...selectedTopic, label: trimmedValue });
        setIsEditing(false);
        
        // Call callbacks if they exist
        if (closeSelectedTopic) closeSelectedTopic();
        if (setTopicChanged) setTopicChanged(true);
        
      } else {
        // Handle API failure
        setRenameError(result?.message || "Rename failed. Please try again.");
      }
      
    } catch (err) {
      console.error("Rename failed with error:", err);
      setRenameError(t("Rename failed. Try again."));
    } finally {
      // Always reset loading state
      setRenameLoading(false);
    }
  };

  // Helper to build a custom tree with checkboxes styled like TopTopics
  const renderTopicTree = (topics, level = 0) => {
    if (!topics || topics.length === 0) return null;
    return (
      <ul style={{ listStyle: 'none', paddingLeft: level === 0 ? 0 : 18 }}>
        {topics.map(topic => (
          <li key={topic.id} style={{ marginBottom: 6 }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: theme === 'dark' ? '#fff' : '#333' }}>
              <input
                type="checkbox"
                className={topTopicsStyles.topicCheckBox}
                checked={selectedParent === topic.id}
                onChange={() => setSelectedParent(topic.id)}
                style={{ marginRight: 8 }}
              />
              <span style={{ fontWeight: level === 0 ? 600 : 400 }}>{topic.name || topic.label}</span>
            </label>
            {topic.child && topic.child.length > 0 && renderTopicTree(topic.child, level + 1)}
          </li>
        ))}
      </ul>
    )
  } // <-- Add this missing closing bracket for renderTopicTree

  const initFraudDoughnutData = (fraud_dist = {}) => {
    if (fraud_dist && Object.keys(fraud_dist).length > 0) {
      const datas = [];
      const labels = [];
      const backgroundColors = [];
      const hoverBackgroundColors = [];
      const total = Object.values(fraud_dist).reduce((a, b) => a + b, 0);

      Object.keys(fraud_dist).forEach((key) => {
        const count = fraud_dist[key];
        const percent = total > 0 ? ((count / total) * 100).toFixed(2) : 0;
        let label, color;
        if (key === "true" || key === true) {
          label = `Not Fraud`;
          color = "#4CAF50"; // green
        } else if (key === "false" || key === false) {
          label = `Fraud`;
          color = "#F44336"; // red
        } else {
          label = `${key}`;
          color = "#FFA726"; // orange for unknown
        }
        datas.push(count);
        labels.push(label);
        backgroundColors.push(color);
        hoverBackgroundColors.push(color);
      });

      const fraudData = {
        maintainAspectRatio: false,
        responsive: true,
        text: 'Fraud',
        labels: labels,
        ids: Object.keys(fraud_dist),
        datasets: [
          {
            data: datas,
            backgroundColor: backgroundColors,
            hoverBackgroundColor: hoverBackgroundColors,
          },
        ],
      };
      setFraudDoughnutData(fraudData);
    } else {
      setFraudDoughnutData({});
    }
    setIsFraudDoughnutDataLoading(false);
  };

  useEffect(() => {
    console.log("parent id to see it ",selectedTopic?.parent_id)
    if (repositionModalOpen) {
      setSelectedParent(selectedTopic?.parent_id ? selectedTopic.parent_id : 'none');
    }
  }, [repositionModalOpen, selectedTopic]);

  return (
    <div id="SelectedTopicInfo">
      {/* Topic Actions Panel - styled like the provided image */}
      {!shared && topicsType !== "fixed" && topicsType !== "custom" && (
        <BoardCard title={t("Topic Actions")}>
      
          <div style={{ width: "100%", position: "relative", marginBottom: 18 }}>
            <input
              className={styles.renameInput}
              value={renameValue}
              onChange={isEditing ? handleRenameChange : undefined}
              maxLength={maxLen}
              minLength={minLen}
              readOnly={!isEditing}
              aria-label={t("Rename topic")}
              style={{ paddingRight: 36, cursor: isEditing ? "text" : "pointer" }}
              onFocus={() => { if (!isEditing) handleRenameClick(); }}
            />
            <span
              className={styles.inputPenIcon}
              style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: isEditing ? styles.primaryColor : "#888" }}
              onClick={handleRenameClick}
              tabIndex={0}
              role="button"
              aria-label={t("Edit topic name")}
            >
              <EditOutlined />
            </span>
            <span className={styles.charCount} style={{ position: "absolute", right: 36, top: "50%", transform: "translateY(-50%)", fontSize: 12 }}>{charCount}/{maxLen}</span>
            {renameError && <span className={styles.renameError}>{renameError}</span>}
          </div>
          <div className={styles.actionsRow}>
            <button
              className={styles.renameBtn}
              onClick={handleRename}
              disabled={
                renameLoading ||
                !isEditing ||
                renameValue.trim() === "" ||
                renameValue.trim().length < minLen ||
                renameValue.trim().length > maxLen ||
                renameValue.trim() === selectedTopic?.label
              }
              aria-label={t("common.rename", "Rename")}
              style={{ minWidth: 110 }}
            >
              {renameLoading ? <span className={styles.loader}></span> : <CheckOutlined style={{ color: renameSuccess ? '#52c41a' : undefined }} />} {t("common.rename", "Rename")}
            </button>
            <button
              className={styles.deleteBtn}
              onClick={() => setDeleteModalOpen(true)}
              aria-label={t("common.delete", "Delete")}
              disabled={deleteLoading}
              style={{ minWidth: 110 }}
            >
              <DeleteOutlined /> {t("common.delete", "Delete")}
            </button>
            {isCombinedView && (
              <button
                className={styles.repositionBtn}
                onClick={() => {
                  if (!repositionLoading && !topTopicsLoading && !parentOptionsLoading) {
                    setRepositionModalOpen(true);
                    fetchParentOptions();
                  }
                }}
                aria-label={t("common.reposition", "Reposition")}
                disabled={repositionLoading || topTopicsLoading || parentOptionsLoading}
                style={{ minWidth: 110 }}
              >
                {(repositionLoading || topTopicsLoading || parentOptionsLoading) ? (
                  <LoadingOutlined style={{ marginRight: 8 }} />
                ) : (
                  <RetweetOutlined style={{ marginRight: 8 }} />
                )}
                {t("common.reposition", "Reposition")}
              </button>
            )}
          </div>
        
        </BoardCard>
      )}
      {filters.length > 0 && (
        <spin spinning={isSentimentDoughnutDataLoading}>
          <div className={styles.searchFilters}>
            <div className={styles.filterFirstRow}>{filters}</div>
            <div
              className={styles.reset}
              onClick={() => {
                !reviewsLoading && handleResetFilter();
              }}
            >
              {t("selected_dashboard_page.5")}
            </div>
          </div>
        </spin>
      )}
      {topicsType !== "ai" &&
        queryFilters?.selected_topic?.id &&
        allItems?.length > 0 &&
        allItems.find((item) => {
          if (
            item.TopicId === parseInt(queryFilters?.selected_topic?.id, 10) ||
            item.topic_id === parseInt(queryFilters?.selected_topic?.id, 10)
          )
            return item;
        }) && (
          <CustomSummaryItem
            close={closeSelectedTopic}
            setSelectedTopic={setSelectedTopic}
            DashboardId={DashboardId}
            item={
              params.get("view_type") === "trends"
                ? allItems?.find(
                  (item) =>
                    item.TopicId ===
                    parseInt(queryFilters?.selected_topic?.id, 10)
                )
                : allItems?.find(
                  (item) =>
                    item.topic_id ===
                    parseInt(queryFilters?.selected_topic?.id, 10)
                )
            }
            toggleListCard={toggleListCard}
            topicsType={topicsType}
            uniqueAllDates={uniqueAllDates}
            fillZeros={fillZeros}
          />
        )}
      <div className={styles.numericDataContainer}>
        {selectedTopicData?.UniqueUsers !== 0 &&
          DashboardReducer?.dashboard?.PlatformId !== 11 && (
            <BoardCard title={t("selected_dashboard_page.57")}>
              <span>{selectedTopicData?.UniqueUsers || 0}</span>
            </BoardCard>
          )}
        <BoardCard
          title={
            <span className={styles.KDATitle}>
              <span>
                {filters?.length > 0
                  ? t("selected_dashboard_page.73")
                  : t("selected_dashboard_page.58")}
              </span>
              <Tooltip
                title={
                  params.get("since") && params.get("until")
                    ? t("dashboard_tooltips.filtered_data.1", {
                      since: params.get("since"),
                      until: params.get("until"),
                    })
                    : t("dashboard_tooltips.filtered_data.2")
                }
                color="#100D31"
              >
                <img
                  className={styles.message_img}
                  src={
                    theme === "dark"
                      ? "/assets/info1.svg"
                      : "/assets/info1_black.svg"
                  }
                />
              </Tooltip>
            </span>
          }
        >
          <Spin spinning={isSentimentDoughnutDataLoading}>
            <div className={styles.dataWrapper}>
              <span>{rawData}</span>
            </div>
          </Spin>
        </BoardCard>
        {avgRating !== 0 && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.59")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.avg_rating.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.avg_rating.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
          >
            <Spin spinning={isSentimentDoughnutDataLoading}>
              <div className={styles.dataWrapper}>
                <span>{avgRating}</span>
              </div>
            </Spin>
          </BoardCard>
        )}
      </div>
      <div className={styles.hotContainer}>
        {(selectedTopicData?.TopWords || selectedTopicData?.AllKeyword) && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>
                  {topicsType === "custom"
                    ? selectedTopicData?.AllKeyword?.length === 0 ||
                      selectedTopicData?.AllKeyword?.every(
                        (word) => !word || word === ""
                      )
                      ? t("selected_dashboard_page.98")
                      : t("selected_dashboard_page.61")
                    : t("selected_dashboard_page.62")}
                </span>
                <Tooltip
                  title={
                    topicsType === "custom"
                      ? selectedTopicData?.AllKeyword?.length === 0 ||
                        selectedTopicData?.AllKeyword?.every(
                          (word) => !word || word === ""
                        )
                        ? t("dashboard_tooltips.classifier")
                        : t("dashboard_tooltips.rules")
                      : t("dashboard_tooltips.top_words")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
          >
            <div className={styles.topWordsWrapper}>
              {(selectedTopicData?.TopWords || []).map((word) => {
                if (!word || word === "") return;

                return (
                  <Tag.CheckableTag
                    key={word}
                    checked={selectedTags?.find((item) => item.label === word)}
                    onChange={(checked) =>
                      handleTagSelection(word, checked, "top_words")
                    }
                  >
                    {word}
                  </Tag.CheckableTag>
                );
              })}
              {(
                (topicsType === "custom" && selectedTopicData?.AllKeyword) ||
                []
              ).map((word) => {
                return (
                  <div className={styles.ruleBox}>
                    {!word || word === "" ? (
                      "Multi-label Model"
                    ) : (
                      <>
                        <p className={styles.rule}>{word}</p>
                        <div className={styles.actions}>
                          <img
                            src={
                              theme === "dark"
                                ? "/assets/copy.svg"
                                : "/assets/copy_black.svg"
                            }
                            onClick={() => handleCopyRule(word)}
                            alt=""
                          />
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          </BoardCard>
        )}
      </div>
      <div className={styles.analysisContainer}>
        <BoardCard
          title={
            <span className={styles.KDATitle}>
              <span>{`${t("selected_dashboard_page.60")}🔥`}</span>
              <Tooltip
                title={
                  params.get("since") && params.get("until")
                    ? t("dashboard_tooltips.hotterms.1", {
                      since: params.get("since"),
                      until: params.get("until"),
                    })
                    : t("dashboard_tooltips.hotterms.2")
                }
                color="#100D31"
              >
                <img
                  className={styles.message_img}
                  src={
                    theme === "dark"
                      ? "/assets/info1.svg"
                      : "/assets/info1_black.svg"
                  }
                />
              </Tooltip>
            </span>
          }
        >
          <div className={styles.container}>
            <HotTerms
              allNgrams={hottermsData}
              loading={hottermsLoading}
              setLoading={setHottermsLoading}
              overLimit={overLimitForHotterms}
              disableSelection={reviewsLoading || topTopicsLoading}
            />
          </div>
        </BoardCard>
        <BoardCard
          title={
            <span className={styles.KDATitle}>
              <span>{t("others.42")}</span>
              <Tooltip
                title={
                  params.get("since") && params.get("until")
                    ? t("dashboard_tooltips.top_topics.1", {
                      since: params.get("since"),
                      until: params.get("until"),
                    })
                    : t("dashboard_tooltips.top_topics.2")
                }
                color="#100D31"
              >
                <img
                  className={styles.message_img}
                  src={
                    theme === "dark"
                      ? "/assets/info1.svg"
                      : "/assets/info1_black.svg"
                  }
                />
              </Tooltip>
            </span>
          }
          id="top-topics"
        >
          <Spin spinning={topTopicsLoading}>
            <div className={styles.container}>
              <TopTopics
                data={topTopics}
                topTopicsLoading={topTopicsLoading}
                disableTopTopicsBtn={reviewsLoading || topTopicsLoading}
                selectedTopTopics={selectedTopTopics}
                setSelectedTopTopics={setSelectedTopTopics}
                checkedTopicIds={checkedTopicIds}
                setCheckedTopicIds={setCheckedTopicIds}
                selectedTopicIds={selectedTopicIds}
                setSelectedTopicIds={setSelectedTopicIds}
                handleClearAll={handleClearAllTopTopics}
              />
            </div>
          </Spin>
        </BoardCard>
      </div>
      {npsInfo && Object.keys(npsInfo).length !== 0 && (
        <div className={styles.analysisContainer}>
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>
                  {npsScale[1] === 5
                    ? t("selected_dashboard_page.100")
                    : t("selected_dashboard_page.99")}
                </span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? npsScale[1] === 5
                        ? t("dashboard_tooltips.voc.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                        : t("dashboard_tooltips.nps.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                      : npsScale[1] === 5
                        ? t("dashboard_tooltips.voc.2")
                        : t("dashboard_tooltips.nps.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id="nps-score"
          >
            <Spin spinning={isAvgSentimentGaugeDataLoading}>
              <div className={styles.npsChart}>
                <GaugeChart
                  animate={false}
                  className={styles.sentimentGauge}
                  id="gauge-chart2"
                  nrOfLevels={3}
                  needleColor={theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"}
                  needleBaseColor={
                    theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"
                  }
                  textColor={theme === "dark" ? "white" : "black"}
                  percent={
                    npsScale[1] === 5
                      ? (avgRating - 1) / 4
                      : npsInfo?.nps < 0
                        ? 0.5 - Math.abs(npsInfo?.nps) / 2
                        : 0.5 + npsInfo?.nps / 2
                  }
                  width={200}
                  colors={["#AA2B0E", "#FFA800", "#00B07B"]}
                  formatTextValue={(value) =>
                    npsScale[1] === 5
                      ? parseFloat(avgRating)
                      : npsInfo?.nps * 100
                  }
                />
              </div>
              <div className={styles.npsBarTitle}>{t("label.17")}</div>
              <div className={styles.npsBar}>
                {npsInfo?.detractors > 0 && (
                  <div className={styles.barPercent}>
                    <span
                      onClick={() => handleNPSFilter("detractors")}
                      className={styles.color0}
                      style={{ width: `${npsInfo.detractors * 2}px` }}
                    ></span>
                    <span className={styles.percent}>
                      {npsInfo?.detractors}%
                    </span>
                  </div>
                )}
                {npsInfo?.passives > 0 && (
                  <div className={styles.barPercent}>
                    <span
                      onClick={() => handleNPSFilter("neutrals")}
                      className={styles.color2}
                      style={{ width: `${npsInfo.passives * 2}px` }}
                    ></span>
                    <span className={styles.percent}>{npsInfo?.passives}%</span>
                  </div>
                )}
                {npsInfo?.promoters > 0 && (
                  <div className={styles.barPercent}>
                    <span
                      onClick={() => handleNPSFilter("promoters")}
                      className={styles.color3}
                      style={{ width: `${npsInfo.promoters * 2}px` }}
                    ></span>
                    <span className={styles.percent}>
                      {npsInfo?.promoters}%
                    </span>
                  </div>
                )}
              </div>
              {npsInfo?.detractors > 0 && (
                <div className={styles.npsBarTitle}>
                  {t("selected_dashboard_page.149")}
                </div>
              )}
              <div className={styles.npsBar}>
                {npsInfo?.deep_detractors > 0 && (
                  <div className={styles.barPercent}>
                    <span
                      onClick={() => handleNPSFilter("deep detractors")}
                      className={styles.color01}
                      style={{ width: `${npsInfo.deep_detractors * 2}px` }}
                    ></span>
                    <span className={styles.percent}>
                      {npsInfo?.deep_detractors}%
                    </span>
                  </div>
                )}
                {npsInfo?.detractors2 > 0 && (
                  <div className={styles.barPercent}>
                    <span
                      onClick={() => handleNPSFilter("other detractors")}
                      className={styles.color02}
                      style={{ width: `${npsInfo.detractors2 * 2}px` }}
                    ></span>
                    <span className={styles.percent}>
                      {npsInfo?.detractors2}%
                    </span>
                  </div>
                )}
              </div>
              <div className={styles.npsLabels}>
                <div className={styles.labelItem0}>
                  <span></span>
                  {`${t("selected_dashboard_page.149")} [${npsScale[1] === 5 ? `1-3` : `0-6`
                    }]`}
                </div>
                <div className={styles.labelItem01}>
                  <span></span>
                  {`${t("selected_dashboard_page.148")} [${npsScale[1] === 5 ? `1-2` : `0-3`
                    }]`}
                </div>
                <div className={styles.labelItem02}>
                  <span></span>
                  {`${t("selected_dashboard_page.150")} [${npsScale[1] === 5 ? `3` : `4-6`
                    }]`}
                </div>
                <div className={styles.labelItem1}>
                  <span></span>
                  {`${t("selected_dashboard_page.151")} [${npsScale[1] === 5 ? 4 : `7-8`
                    }]`}
                </div>
                <div className={styles.labelItem2}>
                  <span></span>
                  {`${t("selected_dashboard_page.152")} [${npsScale[1] === 5 ? 5 : `9-10`
                    }]`}
                </div>
              </div>
            </Spin>
          </BoardCard>
        </div>
      )}
      <div className={styles.ac}>
        {(DashboardReducer?.dashboard?.PlatformId === 11 ||
          DashboardReducer?.dashboard?.PlatformId === 12 ||
          DashboardReducer?.dashboard?.PlatformId === 13) && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.97")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.platform.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                        : t("dashboard_tooltips.platform.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Platform-Analysis"
            >
              <div className={styles.doughnutWrapper}>
                <Spin spinning={isPlatformDoughnutDataLoading}>
                  <CustomChart
                    data={platformData}
                    height={150}
                    type="doughnut"
                    options={{
                      ...basicDoughnutOptions,
                      onClick: (e) => {
                        var point = e.chart?.getElementsAtEventForMode(
                          e,
                          "nearest",
                          {
                            intersect: true,
                          }
                        );
                        if (point?.length > 0) {
                          handleDoughnutClick(point[0], "platform");
                        } else {
                          return;
                        }
                      },
                      plugins: {
                        ...basicDoughnutOptions.plugins,
                        legend: {
                          ...basicDoughnutOptions.plugins.legend,
                          onClick: (event, legendItem) => {
                            handleDoughnutClick(legendItem, "platform");
                          },
                        },
                      },
                    }}
                    theme={theme}
                  />
                </Spin>
              </div>
            </BoardCard>
          )}
        {intentDoughnutData?.datasets && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.12")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.intent.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.intent.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id="Intent-Analysis"
          >
            <div className={styles.doughnutWrapper}>
              <Spin spinning={isIntentDoughnutDataLoading}>
                <CustomChart
                  data={intentDoughnutData}
                  type="doughnut"
                  height={150}
                  options={{
                    ...basicDoughnutOptions,
                    onClick: (e) => {
                      var point = e.chart?.getElementsAtEventForMode(
                        e,
                        "nearest",
                        {
                          intersect: true,
                        }
                      );
                      if (point?.length > 0) {
                        handleDoughnutClick(point[0], "intent");
                      } else {
                        return;
                      }
                    },
                    plugins: {
                      ...basicDoughnutOptions.plugins,
                      legend: {
                        ...basicDoughnutOptions.plugins.legend,
                        onClick: (event, legendItem) => {
                          handleDoughnutClick(legendItem, "intent");
                        },
                      },
                    },
                  }}
                  theme={theme}
                />
              </Spin>
            </div>
          </BoardCard>
        )}
      </div>
      <div className={styles.ac}>
        <BoardCard
          title={
            <span className={styles.KDATitle}>
              <span>{t("selected_dashboard_page.10")}</span>
              <Tooltip
                title={
                  params.get("since") && params.get("until")
                    ? t("dashboard_tooltips.avg_sent.1", {
                      since: params.get("since"),
                      until: params.get("until"),
                    })
                    : t("dashboard_tooltips.avg_sent.2")
                }
                color="#100D31"
              >
                <img
                  className={styles.message_img}
                  src={
                    theme === "dark"
                      ? "/assets/info1.svg"
                      : "/assets/info1_black.svg"
                  }
                />
              </Tooltip>
            </span>
          }
          id="Overall-Sentiment-Analysis"
        >
          <Spin spinning={isAvgSentimentGaugeDataLoading}>
            <GaugeChart
              className={styles.sentimentGauge}
              animate={false}
              id="gauge-chart1"
              nrOfLevels={3}
              percent={avgSentiment || 0}
              formatTextValue={(value) => value}
              colors={[
                "rgba(220, 37, 37, 1)",
                "rgb(255, 255, 0)",
                "rgba(16, 200, 0, 1)",
              ]}
              needleColor={theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"}
              needleBaseColor={theme === "dark" ? "rgb(70, 74, 79)" : "#a6a6a6"}
              textColor={theme === "dark" ? "white" : "black"}
            />
          </Spin>
        </BoardCard>
        {sentimentDoughnutData?.datasets && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.11")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.sentiment.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.sentiment.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id="Detailed-Sentiment-Analysis"
          >
            <div className={styles.doughnutWrapper}>
              <Spin spinning={isSentimentDoughnutDataLoading}>
                <CustomChart
                  data={sentimentDoughnutData}
                  type="doughnut"
                  height={150}
                  options={{
                    ...basicDoughnutOptions,
                    onClick: (e) => {
                      var point = e.chart?.getElementsAtEventForMode(
                        e,
                        "nearest",
                        {
                          intersect: true,
                        }
                      );
                      if (point?.length > 0) {
                        handleDoughnutClick(point[0], "sentiment");
                      } else {
                        return;
                      }
                    },
                    plugins: {
                      ...basicDoughnutOptions.plugins,
                      legend: {
                        ...basicDoughnutOptions.plugins.legend,
                        onClick: (event, legendItem) => {
                          handleDoughnutClick(legendItem, "sentiment");
                        },
                      },
                    },
                  }}
                  theme={theme}
                />
              </Spin>
            </div>
          </BoardCard>
        )}
        {fraudDoughnutData && fraudDoughnutData.labels && fraudDoughnutData.labels.length > 0 && (
        <BoardCard title={<span className={styles.KDATitle}>{t('selected_dashboard_page.166')}</span>} id="FraudDoughnut">
          <div className={styles.doughnutWrapper}>
            <Spin spinning={isFraudDoughnutDataLoading}>
              <CustomChart
                data={fraudDoughnutData}
                type="doughnut"
                height={150}
                options={{
                  ...basicDoughnutOptions,
                  onClick: (e) => {
                    var point = e.chart?.getElementsAtEventForMode(
                      e,
                      "nearest",
                      {
                        intersect: true,
                      }
                    );
                    if (point?.length > 0) {
                      handleDoughnutClick(point[0], "fraud");
                    } else {
                      return;
                    }
                  },
                  plugins: {
                    ...basicDoughnutOptions.plugins,
                    legend: {
                      ...basicDoughnutOptions.plugins.legend,
                      onClick: (event, legendItem) => {
                        handleDoughnutClick(legendItem, "fraud");
                      },
                    },
                  },
                }}
                theme={theme}
              />
            </Spin>
          </div>
        </BoardCard>
      )}
        {ratingDoughnutData &&
          ratingDoughnutData?.datasets &&
          ratingDoughnutData.labels?.length > 0 && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.13")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.rating.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                        : t("dashboard_tooltips.rating.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Rating-Analysis"
            >
              <div className={styles.doughnutWrapper}>
                <Spin spinning={isRatingDoughnutDataLoading}>
                  <CustomChart
                    data={ratingDoughnutData}
                    type="doughnut"
                    height={150}
                    options={{
                      ...basicDoughnutOptions,
                      onClick: (e) => {
                        var point = e.chart?.getElementsAtEventForMode(
                          e,
                          "nearest",
                          {
                            intersect: true,
                          }
                        );
                        if (point?.length > 0) {
                          handleDoughnutClick(point[0], "rating");
                        } else {
                          return;
                        }
                      },
                      plugins: {
                        ...basicDoughnutOptions.plugins,
                        legend: {
                          ...basicDoughnutOptions.plugins.legend,
                          onClick: (event, legendItem) => {
                            handleDoughnutClick(legendItem, "rating");
                          },
                        },
                      },
                    }}
                    theme={theme}
                  />
                </Spin>
              </div>
            </BoardCard>
          )}
        {volumeDaily && volumeDaily.length !== 0 && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.15")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.vol_daily.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.vol_daily.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id={`Time-based-Participation-${selectedTopic?.label}`}
            extra={
              <Dropdown
                trigger={["click"]}
                overlay={() => timePeriodOptions("participation")}
              >
                <Button
                  style={{
                    color: theme === "dark" ? "#fff" : "#000",
                    backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff",
                    border: 0,
                  }}
                >
                  {participationPeriod ||
                    (volumeDaily &&
                      volumeDaily.length > 0 &&
                      determinePeriod(volumeDaily[0].day)) ||
                    "Monthly"}
                  <DownOutlined />
                </Button>
              </Dropdown>
            }
          >
            <Spin spinning={participationPeriodLoading}>
              <LineChartWrapper
                id="Time-based Participation"
                period={participationPeriod}
                VolumeDaily={
                  participationPeriodLoading
                    ? []
                    : volumeDaily.length
                      ? volumeDaily
                      : DashboardReducer?.boardData?.VolumeDaily
                }
                clickable={true}
              />
            </Spin>
          </BoardCard>
        )}
        {sentimentDaily && sentimentDaily.length !== 0 && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.16")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.sent_daily.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.sent_daily.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id={`Time-based-Sentiment-${selectedTopic?.label}`}
            extra={
              <Dropdown
                trigger={["click"]}
                overlay={() => timePeriodOptions("sentiment")}
              >
                <Button
                  style={{
                    color: theme === "dark" ? "#fff" : "#000",
                    backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff",
                    border: 0,
                  }}
                >
                  {sentimentPeriod ||
                    (sentimentDaily &&
                      sentimentDaily.length > 0 &&
                      determinePeriod(sentimentDaily[0].day)) ||
                    "Monthly"}
                  <DownOutlined />
                </Button>
              </Dropdown>
            }
          >
            <Spin spinning={sentimentPeriodLoading}>
              <LineChartWrapper
                period={participationPeriod}
                SentimentDaily={
                  sentimentPeriodLoading
                    ? []
                    : sentimentDaily.length
                      ? sentimentDaily
                      : DashboardReducer?.boardData?.SentimentDaily
                }
                clickable={true}
              />
            </Spin>
          </BoardCard>
        )}
        {Time_Daily_Rating && Object.keys(Time_Daily_Rating).length > 0 && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.14")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.rat_daily.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.rat_daily.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id="Time-based Ratings"
            extra={
              <Dropdown
                trigger={["click"]}
                overlay={() => timePeriodOptions("Time-based_Ratings")}
              >
                <Button
                  style={{
                    color: theme === "dark" ? "#fff" : "#000",
                    backgroundColor: theme === "dark" ? "#1C193B" : "#ffffff",
                    border: 0,
                  }}
                >
                  {ratingsPeriod || "Monthly"}
                  <DownOutlined />
                </Button>
              </Dropdown>
            }
          >
            <Spin spinning={ratingPeriodLoading}>
              <LineChartWrapper
                id="Time-based Participation"
                Time_Rating={timerating}
                Time_Daily_Rating={Time_Daily_Rating}
                clickable={true}
              />
            </Spin>
          </BoardCard>
        )}
      </div>
      <div className={styles.ac}>
        {topicRatingData &&
          topicRatingData.length > 0 &&
          !topicRatingData
            .map((t) => t?.rating?.value)
            .every((t) => parseInt(t, 10) === 0) && (
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.84")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.tpc_rat.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                        : t("dashboard_tooltips.tpc_rat.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Topics Rating"
              extra={
                <div className={styles.subTopicCards}>
                  <span
                    className={styles.downloadChartsBtn}
                    onClick={() =>
                      handleDownloadChartData(topicRatingData, "Rating")
                    }
                  >
                    {downloadRatingChartsDataLoading ? (
                      <LoadingOutlined
                        style={{
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                          width: "14px",
                          height: "14px",
                        }}
                      />
                    ) : (
                      <i className="fa fa-download" />
                    )}
                  </span>
                  {selectedTopicFromBars &&
                    Object.keys(selectedTopicFromBars).length > 0 && (
                      <div className={styles.selections}>
                        {Object.values(selectedTopicFromBars).map((topic) => (
                          <span
                            key={topic.id}
                            className={styles.level1Label}
                            title={topic.label}
                            onClick={() => {
                              const topics = Object.values(
                                selectedTopicFromBars
                              ).filter((t) => t.level < topic.level);
                              setSelectedTopicFromBars(topics);
                              for (
                                let level = topic.level;
                                level >= 1;
                                level++
                              ) {
                                if (params.has(`level${level}Selection`)) {
                                  params.delete(`level${level}Selection`);
                                  history.push({
                                    search: params.toString(),
                                  });
                                  dispatch({
                                    type: actions.UPDATE_SEARCH_STATE,
                                    payload: {
                                      [`selectedL${level}Topic`]: null,
                                    },
                                  });
                                } else {
                                  break;
                                }
                              }
                            }}
                          >
                            <span>{removeParentFromChildren(topic.label)}</span>
                            <CloseOutlined />
                          </span>
                        ))}
                      </div>
                    )}
                </div>
              }
            >
              <Spin spinning={topicRatingsLoading}>
                <BarChartWrapper
                  data={topicRatingData}
                  selectedTopics={selectedTopicFromBars}
                  setSelectedTopics={setSelectedTopicFromBars}
                  metric={"rating"}
                  onlyOneMetric={
                    !topicSentimentData || topicSentimentData.length === 0
                  }
                />
              </Spin>
            </BoardCard>
          )}
        {topicSentimentData && topicSentimentData.length > 0 && (
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.86")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.tpc_sent.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.tpc_sent.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id="Topics Sentiment"
            extra={
              <div className={styles.subTopicCards}>
                <span
                  className={styles.downloadChartsBtn}
                  onClick={() =>
                    handleDownloadChartData(topicSentimentData, "Sentiment")
                  }
                >
                  {downloadSentimentChartsDataLoading ? (
                    <LoadingOutlined
                      style={{
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "600",
                        width: "16px",
                        height: "16px",
                      }}
                    />
                  ) : (
                    <i className="fa fa-download" />
                  )}
                </span>
                {selectedTopicFromBars &&
                  Object.keys(selectedTopicFromBars).length > 0 && (
                    <div className={styles.selections}>
                      {Object.values(selectedTopicFromBars).map((topic) => (
                        <span
                          key={topic.id}
                          className={styles.level1Label}
                          title={topic.label}
                          onClick={() => {
                            const topics = Object.values(
                              selectedTopicFromBars
                            ).filter((t) => t.level < topic.level);
                            setSelectedTopicFromBars(topics);
                            for (let level = topic.level; level >= 1; level++) {
                              if (params.has(`level${level}Selection`)) {
                                params.delete(`level${level}Selection`);
                                history.push({
                                  search: params.toString(),
                                });
                                dispatch({
                                  type: actions.UPDATE_SEARCH_STATE,
                                  payload: {
                                    [`selectedL${level}Topic`]: null,
                                  },
                                });
                              } else {
                                break;
                              }
                            }
                          }}
                        >
                          <span>{removeParentFromChildren(topic.label)}</span>
                          <CloseOutlined />
                        </span>
                      ))}
                    </div>
                  )}
              </div>
            }
          >
            <Spin spinning={topicRatingsLoading}>
              <BarChartWrapper
                data={topicSentimentData}
                selectedTopics={selectedTopicFromBars}
                setSelectedTopics={setSelectedTopicFromBars}
                metric={"sentiment"}
                stacked={true}
                onlyOneMetric={
                  !topicRatingData ||
                  topicRatingData.length === 0 ||
                  topicRatingData
                    .map((t) => t?.rating?.value)
                    .every((t) => parseInt(t, 10) === 0)
                }
                scrollable={true}
              />
            </Spin>
          </BoardCard>
        )}
      </div>
      {decisionData?.length > 0 &&
        [33, 34, 35].includes(DashboardReducer?.dashboard?.PlatformId) && (
          <div
            className={`${styles.analysisContainer} ${styles.pivotDoughnuts}`}
          >
            <BoardCard
              title={
                <span className={styles.KDATitle}>
                  <span>{t("selected_dashboard_page.157")}</span>
                  <Tooltip
                    title={
                      params.get("since") && params.get("until")
                        ? t("dashboard_tooltips.decision.1", {
                          since: params.get("since"),
                          until: params.get("until"),
                        })
                        : t("dashboard_tooltips.decision.2")
                    }
                    color="#100D31"
                  >
                    <img
                      className={styles.message_img}
                      src={
                        theme === "dark"
                          ? "/assets/info1.svg"
                          : "/assets/info1_black.svg"
                      }
                    />
                  </Tooltip>
                </span>
              }
              id="Decision-Analysis"
            >
              <div className={styles.dnutWrapper}>
                <Spin spinning={decisionDataLoading}>
                  <div className={`${styles.doughnutContainer}`}>
                    {decisionData.map((decsData) => (
                      <div className={styles.doughnut}>
                        <span className={styles.doughnutLabel}>
                          {decsData.doughnutLabel === "publish"
                            ? "Publish"
                            : decsData.doughnutLabel === "opencase"
                              ? "Open Case"
                              : "Take Action"}
                        </span>
                        {decsData.datasets[0].data.reduce(
                          (acc, curr) => acc + parseInt(curr, 10),
                          0
                        ) > 0 ? (
                          <CustomChart
                            data={decsData}
                            options={{
                              ...basicDoughnutOptions,
                              cutout: "55%",
                              onClick: function (e) {
                                var point = e.chart?.getElementsAtEventForMode(
                                  e,
                                  "nearest",
                                  {
                                    intersect: true,
                                  }
                                );
                                if (point?.length > 0) {
                                  const key = decsData.doughnutLabel;
                                  const value =
                                    point[0].index === 0 ? "False" : "True";
                                  handleDecisionDoughnutClick(key, value);
                                }
                              },
                              layout: {
                                padding: {
                                  left: 40,
                                  right: 40,
                                  top: 0,
                                  bottom: 0,
                                },
                              },
                              plugins: {
                                ...basicDoughnutOptions.plugins,
                                legend: {
                                  display: false,
                                },
                                tooltip: {
                                  enabled: false,
                                  external: (context) => {
                                    // Tooltip Element
                                    var tooltipEl = document.getElementById(
                                      "chartjs-tooltip"
                                    );

                                    // Create element on first render
                                    if (!tooltipEl) {
                                      tooltipEl = document.createElement("div");
                                      tooltipEl.id = "chartjs-tooltip";
                                      tooltipEl.innerHTML = "<div></div>";
                                      document.body.appendChild(tooltipEl);
                                    }

                                    // Hide if no tooltip
                                    const tooltipModel = context.tooltip;
                                    if (tooltipModel.opacity === 0) {
                                      if (tooltipEl) {
                                        tooltipEl.remove();
                                      }
                                      return;
                                    }
                                    // Set caret Position
                                    tooltipEl.classList.remove(
                                      "above",
                                      "below",
                                      "no-transform"
                                    );
                                    if (tooltipModel.yAlign) {
                                      tooltipEl.classList.add(
                                        tooltipModel.yAlign
                                      );
                                    } else {
                                      tooltipEl.classList.add("no-transform");
                                    }

                                    function getBody(bodyItem) {
                                      return bodyItem.lines;
                                    }

                                    // Set Text
                                    if (tooltipModel.body) {
                                      let innerHtml =
                                        "<div class=" +
                                        styles.driversTooltip +
                                        ">";
                                      const index =
                                        tooltipModel.dataPoints[0].dataIndex;
                                      const datasetLabel =
                                        decsData.labels[index];
                                      const filteredPercentage =
                                        decsData.datasets[0].data[index];
                                      const filteredCount =
                                        decsData.datasets[0].counts[index];
                                      innerHtml += `
                                    <div class=${styles.topicLabelInTooltip}>
                                      <span class=${styles.fillColor} style="background-color: ${decsData.datasets[0].backgroundColor[index]}"></span>
                                      <span class=${styles.topicLabel}>${datasetLabel}</span>
                                    </div>`;
                                      innerHtml += `
                                        <p class=${styles.tooltipValues}><b>${filteredPercentage}% (${filteredCount})</b></p>
                                      `;
                                      innerHtml += "</div>";
                                      const tooltipRoot = tooltipEl.querySelector(
                                        "div"
                                      );
                                      tooltipRoot.innerHTML = innerHtml;
                                    }
                                    // this will be the overall tooltip
                                    const position = context.chart.canvas.getBoundingClientRect();

                                    // Display, position, and set styles for font
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl.style.position = "absolute";
                                    let left =
                                      position.left +
                                      window.pageXOffset +
                                      tooltipModel.caretX;
                                    if (
                                      left + tooltipEl.offsetWidth >
                                      window.innerWidth
                                    ) {
                                      left =
                                        position.left +
                                        window.pageXOffset / 2 +
                                        tooltipModel.caretX -
                                        tooltipEl.offsetWidth;
                                    }
                                    tooltipEl.style.left = left + "px";
                                    tooltipEl.style.top =
                                      position.top +
                                      window.pageYOffset +
                                      tooltipModel.caretY +
                                      "px";
                                    tooltipEl.style.padding =
                                      tooltipModel.padding +
                                      "px " +
                                      tooltipModel.padding +
                                      "px";
                                    tooltipEl.style.pointerEvents = "none";
                                  },
                                },
                                datalabels: {
                                  color: (context) => {
                                    const bgColor =
                                      context.dataset.backgroundColor[
                                      context.dataIndex
                                      ];
                                    if (
                                      RGBAToHex(bgColor) === "#d2b5f2" ||
                                      RGBAToHex(bgColor) === "#56dec8" ||
                                      RGBAToHex(bgColor) === "#ffbfff" ||
                                      RGBAToHex(bgColor) === "#cccccc" ||
                                      RGBAToHex(bgColor) === "#9bc3de" ||
                                      RGBAToHex(bgColor) === "#e7edef"
                                    ) {
                                      return "#4400AA";
                                    } else {
                                      return "white";
                                    }
                                  },
                                  font: {
                                    size: 12,
                                  },
                                  formatter: (value, context) => {
                                    if (
                                      context.dataset.data[context.dataIndex] ==
                                      0 ||
                                      isNaN(
                                        context.dataset.data[context.dataIndex]
                                      )
                                    ) {
                                      return "";
                                    }
                                    const formattedCount = formatCountsForDoughnuts(
                                      context.dataset.counts[context.dataIndex]
                                    );
                                    const lineBreak = "\n";
                                    const spaceBreak = "\t";
                                    return context.dataset.data[
                                      context.dataIndex
                                    ] < 2
                                      ? ""
                                      : hasAlphabet(formattedCount)
                                        ? `${spaceBreak}${" "}${value +
                                        "%"}${lineBreak}(${formattedCount})`
                                        : `${" "}${value +
                                        "%"}${lineBreak}(${formattedCount})`;
                                  },
                                },
                              },
                            }}
                            type={"doughnut"}
                          />
                        ) : (
                          <div className={styles.emptyDoughnut}>
                            {/* <Doughnut
                                data={decsData}
                                options={{
                                  ...IntentOptions,
                                  cutoutPercentage: 45,
                                  legend: false,
                                  layout: {
                                    padding: {
                                      left: 40,
                                      right: 40,
                                      top: 0,
                                      bottom: 0,
                                    },
                                  },
                                  plugins: {
                                    datalabels: {
                                      font: {
                                        size: 9,
                                      },
                                      formatter: function(value, context) {
                                        if (
                                          context.dataset.data[
                                            context.dataIndex
                                          ] == 0 ||
                                          isNaN(
                                            context.dataset.data[
                                              context.dataIndex
                                            ]
                                          )
                                        ) {
                                          return "";
                                        }
                                      },
                                    },
                                  },
                                }}
                              /> */}
                            <span className={styles.noDataDoughnutMsg}>
                              No Data
                            </span>
                          </div>
                        )}
                        {decsData.datasets[0].data.reduce(
                          (acc, curr) => acc + parseInt(curr),
                          0
                        ) > 0 && (
                            <>
                              <div className={styles.pivotsLegendSingle}>
                                <div
                                  title={decsData.labels[0]}
                                  className={styles.topicLabelInTooltip}
                                >
                                  <span
                                    className={styles.fillColor}
                                    style={{
                                      backgroundColor:
                                        decsData.doughnutLabel === "publish"
                                          ? hexToRGBA("#3A6D8C", 1)
                                          : decsData.doughnutLabel === "opencase"
                                            ? hexToRGBA("#D91656", 1)
                                            : hexToRGBA("#304463", 1),
                                    }}
                                  ></span>
                                  <span
                                    onClick={() => {
                                      handleDecisionDoughnutClick(
                                        decsData.doughnutLabel,
                                        "False"
                                      );
                                    }}
                                    className={styles.topicLabel}
                                  >
                                    {decsData.labels[0]}
                                  </span>
                                </div>
                              </div>
                              <div className={styles.pivotsLegendSingle}>
                                <div
                                  title={decsData.labels[1]}
                                  className={styles.topicLabelInTooltip}
                                >
                                  <span
                                    className={styles.fillColor}
                                    style={{
                                      backgroundColor:
                                        decsData.doughnutLabel === "publish"
                                          ? hexToRGBA("#41B3A2", 1)
                                          : decsData.doughnutLabel === "opencase"
                                            ? hexToRGBA("704264", 1)
                                            : hexToRGBA("#758694", 1),
                                    }}
                                  ></span>
                                  <span
                                    onClick={() => {
                                      handleDecisionDoughnutClick(
                                        decsData.doughnutLabel,
                                        "True"
                                      );
                                    }}
                                    className={styles.topicLabel}
                                  >
                                    {decsData.labels[1]}
                                  </span>
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    ))}
                  </div>
                </Spin>
              </div>
            </BoardCard>
          </div>
        )}
      {restaurantDoughnutData && restaurantDoughnutData.length > 0 && (
        <div className={`${styles.analysisContainer} ${styles.pivotDoughnuts}`}>
          <BoardCard
            title={
              <span className={styles.KDATitle}>
                <span>{t("selected_dashboard_page.17")}</span>
                <Tooltip
                  title={
                    params.get("since") && params.get("until")
                      ? t("dashboard_tooltips.pivot.1", {
                        since: params.get("since"),
                        until: params.get("until"),
                      })
                      : t("dashboard_tooltips.pivot.2")
                  }
                  color="#100D31"
                >
                  <img
                    className={styles.message_img}
                    src={
                      theme === "dark"
                        ? "/assets/info1.svg"
                        : "/assets/info1_black.svg"
                    }
                  />
                </Tooltip>
              </span>
            }
            id="Detailed-Pivot-Analysis"
          >
            {multiLevelOptions &&
              Object.keys(multiLevelOptions?.level1)?.length > 0 &&
              !reviewsLoading && (
                <span className={styles.dropdownForPivots}>
                  <MLDropdown
                    title={
                      <span className={styles.pivotFilters}>
                        {t("selected_dashboard_page.138")} <DownOutlined />
                      </span>
                    }
                    level1Pos={"right"}
                    subLevelPos={"right-top"}
                    levelWiseOptions={multiLevelOptions}
                    levelWiseSelections={levelWisePivotSelections}
                    setLevelWiseSelections={setLevelWisePivotSelections}
                    reset={handleResetPivotFilters}
                    apply={(val) => handleApplyPivotFilters(val)}
                    selectedFilterType={selectedPivotsOperator}
                    setSelectedFilterType={setSelectedPivotsOperator}
                  />
                </span>
              )}
            <div className={styles.doughnutWrapper}>
              <Spin spinning={isRestaurantDoughnutDataLoading}>
                <div className={styles.doughnutContainer}>
                  {restaurantDoughnutData.map((restaurentData, index) => (
                    <div
                      className={
                        restaurantRef.current[index]?.current?.filtersApplied
                          ? styles.doughnut
                          : styles.unfilteredDoughnut
                      }
                    >
                      <span className={styles.doughnutLabel}>
                        {restaurentData.doughnutLabel}
                      </span>
                      <CustomChart
                        type="doughnut"
                        data={restaurentData}
                        options={{
                          ...basicDoughnutOptions,
                          cutout: "55%",
                          onClick: function (e) {
                            var point = e.chart?.getElementsAtEventForMode(
                              e,
                              "nearest",
                              {
                                intersect: true,
                              }
                            );
                            if (point?.length > 0) {
                              const key = restaurentData.doughnutLabel;
                              const value =
                                restaurentData.labels[point[0].index];
                              if (point[0].index === 6 && value === "Others") {
                                return;
                              }
                              handlePivotDoughnutClick(key, value);
                            }
                          },
                          layout: {
                            padding: (chartInstance) => {
                              if (!chartInstance.chart.filtersApplied) {
                                return {
                                  left: 0,
                                  right: 0,
                                  top: 0,
                                  bottom: 0,
                                };
                              } else {
                                return {
                                  left: 40,
                                  right: 40,
                                  top: 20,
                                  bottom: 20,
                                };
                              }
                            },
                          },
                          plugins: {
                            ...basicDoughnutOptions.plugins,
                            legend: {
                              display: false,
                            },
                            tooltip: {
                              enabled: false,
                              external: (context) => {
                                // Tooltip Element
                                var tooltipEl = document.getElementById(
                                  "chartjs-tooltip"
                                );

                                // Create element on first render
                                if (!tooltipEl) {
                                  tooltipEl = document.createElement("div");
                                  tooltipEl.id = "chartjs-tooltip";
                                  tooltipEl.innerHTML = "<div></div>";
                                  document.body.appendChild(tooltipEl);
                                }

                                // Hide if no tooltip
                                const tooltipModel = context.tooltip;
                                if (tooltipModel.opacity === 0) {
                                  if (tooltipEl) {
                                    tooltipEl.remove();
                                  }
                                  return;
                                }
                                // Set caret Position
                                tooltipEl.classList.remove(
                                  "above",
                                  "below",
                                  "no-transform"
                                );
                                if (tooltipModel.yAlign) {
                                  tooltipEl.classList.add(tooltipModel.yAlign);
                                } else {
                                  tooltipEl.classList.add("no-transform");
                                }

                                function getBody(bodyItem) {
                                  return bodyItem.lines;
                                }

                                // Set Text
                                if (tooltipModel.body) {
                                  let innerHtml =
                                    "<div class=" + styles.driversTooltip + ">";
                                  const index =
                                    tooltipModel.dataPoints[0].dataIndex;
                                  const datasetLabel =
                                    restaurentData.labels[index];
                                  const filteredPercentage =
                                    restaurentData.datasets[0].data[index];
                                  const filteredCount =
                                    restaurentData.datasets[0].counts[index];
                                  const actualPercentage =
                                    restaurentData.datasets[0].actualData[
                                    index
                                    ];
                                  const actualCount =
                                    restaurentData.datasets[0].actualCounts[
                                    index
                                    ];
                                  if (
                                    filteredCount >= 0 &&
                                    filteredPercentage >= 0 &&
                                    actualPercentage >= 0 &&
                                    actualCount >= 0
                                  ) {
                                    innerHtml += `
                                    <div class=${styles.topicLabelInTooltip}>
                                      <span class=${styles.fillColor} style="background-color: ${restaurentData.datasets[0].backgroundColor[index]}"></span>
                                      <span class=${styles.topicLabel}>${datasetLabel}</span>
                                    </div>`;
                                    if (filters?.length > 0) {
                                      innerHtml += `
                                        <p class=${styles.tooltipValues}>Filtered Data: ${filteredPercentage}% (${filteredCount})</p>
                                        <p class=${styles.tooltipValues}>Actual Data: ${actualPercentage}% (${actualCount})</p>
                                      `;
                                    } else {
                                      innerHtml += `
                                        <p class=${styles.tooltipValues}>Actual Data: ${actualPercentage}% (${actualCount})</p>
                                      `;
                                    }
                                  }
                                  innerHtml += "</div>";
                                  const tooltipRoot = tooltipEl.querySelector(
                                    "div"
                                  );
                                  tooltipRoot.innerHTML = innerHtml;
                                }
                                // this will be the overall tooltip
                                const position = context.chart.canvas.getBoundingClientRect();

                                // Display, position, and set styles for font
                                tooltipEl.style.opacity = 1;
                                tooltipEl.style.position = "absolute";
                                let left =
                                  position.left +
                                  window.pageXOffset +
                                  tooltipModel.caretX;
                                if (
                                  left + tooltipEl.offsetWidth >
                                  window.innerWidth
                                ) {
                                  left =
                                    position.left +
                                    window.pageXOffset / 2 +
                                    tooltipModel.caretX -
                                    tooltipEl.offsetWidth;
                                }
                                tooltipEl.style.left = left + "px";
                                tooltipEl.style.top =
                                  position.top +
                                  window.pageYOffset +
                                  tooltipModel.caretY +
                                  "px";
                                tooltipEl.style.padding =
                                  tooltipModel.padding +
                                  "px " +
                                  tooltipModel.padding +
                                  "px";
                                tooltipEl.style.pointerEvents = "none";
                              },
                            },
                            datalabels: {
                              color: (context) => {
                                const bgColor =
                                  context.dataset.backgroundColor[
                                  context.dataIndex
                                  ];
                                if (
                                  RGBAToHex(bgColor) === "#d2b5f2" ||
                                  RGBAToHex(bgColor) === "#56dec8" ||
                                  RGBAToHex(bgColor) === "#ffbfff" ||
                                  RGBAToHex(bgColor) === "#cccccc" ||
                                  RGBAToHex(bgColor) === "#9bc3de" ||
                                  RGBAToHex(bgColor) === "#e7edef"
                                ) {
                                  return "#4400AA";
                                } else {
                                  return "white";
                                }
                              },
                              font: {
                                size: 12,
                              },
                              formatter: (value, context) => {
                                if (
                                  context.dataset.data[context.dataIndex] ==
                                  0 ||
                                  isNaN(context.dataset.data[context.dataIndex])
                                ) {
                                  return "";
                                }
                                const formattedCount = formatCountsForDoughnuts(
                                  context.dataset.counts[context.dataIndex]
                                );
                                const lineBreak = "\n";
                                const spaceBreak = "\t";
                                return context.dataset.data[context.dataIndex] <
                                  2
                                  ? ""
                                  : hasAlphabet(formattedCount)
                                    ? `${spaceBreak}${" "}${value +
                                    "%"}${lineBreak}(${formattedCount})`
                                    : `${" "}${value +
                                    "%"}${lineBreak}(${formattedCount})`;
                              },
                            },
                          },
                        }}
                        theme={theme}
                        ref={
                          restaurantRef.current[index] ||
                          (restaurantRef.current[index] = createRef())
                        }
                        plugins={[
                          {
                            beforeDraw: (chart) => {
                              if (chart.filtersApplied) {
                                var ctx = chart.ctx;
                                var datasets = chart.data.datasets;
                                datasets.forEach((dataset, i) => {
                                  var meta = chart.getDatasetMeta(i);
                                  meta.data.forEach((elem, index) => {
                                    ctx.save();
                                    var outerRadius = elem.outerRadius + 10;
                                    var startAngle = elem.startAngle;
                                    var endAngle = elem.endAngle;

                                    var halfAngle = (endAngle - startAngle) / 4;
                                    var halfStartAngle = startAngle;
                                    var halfEndAngle =
                                      startAngle + halfAngle * 2;
                                    var halfMidAngle =
                                      (halfStartAngle + halfEndAngle) / 2;
                                    var x =
                                      elem.x +
                                      Math.cos(halfMidAngle) *
                                      (outerRadius + 15);
                                    var y =
                                      elem.y +
                                      Math.sin(halfMidAngle) *
                                      (outerRadius + 15);
                                    const filteredPercentage =
                                      dataset.data[index];
                                    const actualPercentage =
                                      dataset.actualData[index];
                                    var diffValue =
                                      filteredPercentage - actualPercentage;
                                    if (
                                      dataset.data[index] > 3 &&
                                      diffValue !== 0
                                    ) {
                                      // Draw outer ring
                                      ctx.save();
                                      ctx.beginPath();
                                      ctx.strokeStyle =
                                        elem.options.backgroundColor;
                                      ctx.lineWidth = 3;
                                      ctx.arc(
                                        elem.x,
                                        elem.y,
                                        outerRadius,
                                        halfStartAngle,
                                        halfEndAngle
                                      );
                                      ctx.stroke();

                                      // Draw number
                                      ctx.font = "bold 12px Poppins";

                                      ctx.textAlign = "center";
                                      ctx.textBaseline = "middle";
                                      ctx.fillStyle =
                                        theme === "dark" ? "white" : "black";
                                      ctx.fillText(
                                        diffValue > 0
                                          ? "+" + diffValue
                                          : diffValue < 0
                                            ? diffValue
                                            : 0,
                                        x,
                                        y
                                      );
                                      ctx.save();
                                      ctx.restore();
                                    }
                                  });
                                });
                              }
                            },
                          },
                        ]}
                      />
                      <div
                        className={
                          restaurentData.labels.length === 1
                            ? styles.pivotsLegendSingle
                            : styles.pivotsLegend
                        }
                      >
                        {restaurentData.labels.map((label) => (
                          <div
                            title={label}
                            className={styles.topicLabelInTooltip}
                          >
                            <span
                              className={styles.fillColor}
                              style={{
                                backgroundColor: hexToRGBA(
                                  restaurantColorMap[label],
                                  1.0
                                ),
                              }}
                            ></span>
                            <span
                              onClick={() => {
                                if (label !== "Others") {
                                  handlePivotDoughnutClick(
                                    restaurentData.doughnutLabel,
                                    label
                                  );
                                }
                              }}
                              className={styles.topicLabel}
                            >
                              {label}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </Spin>
            </div>
          </BoardCard>
        </div>
      )}
      <div className={styles.chartReviewsContainer} id="reviews_list">
        <BoardCard
          title={
            <span className={styles.KDATitle}>
              <img
                className={styles.message_img}
                src={
                  theme === "dark"
                    ? "/assets/reviews_icon.svg"
                    : "/assets/reviews_icon_black.svg"
                }
              />
              <span>
                {numReviews
                  ? `${t("selected_dashboard_page.18")}: ${numReviews}`
                  : t("selected_dashboard_page.18")}
              </span>
              <Tooltip
                title={
                  params.get("since") && params.get("until")
                    ? t("dashboard_tooltips.reviews.1", {
                      since: params.get("since"),
                      until: params.get("until"),
                    })
                    : t("dashboard_tooltips.reviews.2")
                }
                color="#100D31"
                pointAtCenter
                autoAdjustOverflow
              >
                <img
                  className={styles.message_img}
                  src={
                    theme === "dark"
                      ? "/assets/info1.svg"
                      : "/assets/info1_black.svg"
                  }
                />
              </Tooltip>
            </span>
          }
          theme={theme}
          extra={
            !shared && (
              <div className={styles.reviewsHeaderActions}>
                {![65, 66, 67, 68, 69, 70].includes(userReducer?.PackageId) && (
                  <div className={styles.shareBtn}>
                    <span
                      type="primary"
                      style={{ borderRadius: "8px" }}
                      disabled={[74, 75, 66, 65, 67].includes(
                        userReducer?.PackageId
                      )}
                      className={styles.downloadBtn}
                      onClick={handleShowFileType}
                    >
                      <img
                        className={styles.downloadReviewIcon}
                        src={
                          theme === "dark"
                            ? "/assets/download.svg"
                            : "/assets/download_black.svg"
                        }
                        alt=""
                      />
                      <span className={styles.downloadReviewText}>
                        {t("button.25")}
                      </span>
                    </span>
                  </div>
                )}
                <Dropdown
                  trigger={["click"]}
                  placement="bottomRight"
                  overlayClassName={styles.aiInsightDropdownOverlay}
                  overlay={
                    <Menu className={styles.aiInsightDropdownMenu}>
                      <Menu.Item
                        key="ai-insight"
                        onClick={() => setShowAIInsightsModal(true)}
                        className={styles.aiInsightDropdownItem}
                      >
                        <i className="fa fa-magic" aria-hidden />
                        <span>{t("common.aiInsightsTitle")}</span>
                      </Menu.Item>
                      <Menu.Item
                        key="create-task"
                        onClick={() => {
                          if (
                            userReducer?.trello_status === "active" ||
                            userReducer?.clickup_status === "active" ||
                            userReducer?.jira_status === "active"
                          ) {
                            setCreateTaskModal(true);
                          } else {
                            notification.info({
                              message: t("notifications.48"),
                              icon: (
                                <InfoCircleOutlined
                                  style={{
                                    color: theme === "dark" ? "white" : "black",
                                  }}
                                />
                              ),
                            });
                          }
                        }}
                        className={styles.aiInsightDropdownItem}
                      >
                        <CheckSquareOutlined />
                        <span>{t("review.2")}</span>
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <button
                    type="button"
                    className={styles.aiInsightDropdownBtn}
                    aria-label={t("common.aiInsightsTitle")}
                  >
                    <i className="fa fa-magic" aria-hidden />
                  </button>
                </Dropdown>
              </div>
            )
          }
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <CustomInput
              value={searchWord}
              placeholder={t("placeholder.13")}
              onOk={() => handleSearchWord(searchWord, true, true)}
              onChange={setSearchWord}
              style={{ margin: "20px auto" }}
              extra={
                <Button
                  type="primary"
                  onClick={() => handleSearchWord(searchWord, true, true)}
                  disabled={reviewsLoading}
                >
                  {t("button.5")}
                </Button>
              }
              disabled={reviewsLoading}
            />
            <ReviewsList
              reviewsLoading={reviewsLoading}
              allReviews={allReviews}
              numReviews={numReviews}
              startIndex={startIndex}
              setStartIndex={setStartIndex}
              numOfDocs={numOfDocs}
              highlights={highlights}
              setNumOfDocs={setNumOfDocs}
              getAllReviews={getSearchResults}
              getOnlyReviews={getOnlyReviews}
              setReviewsLoading={setReviewsLoading}
              getHighlights={getHighlights}
              handleTagSelection={handleTagSelection}
              user={user}
              shared={shared}
              currentDashboardHash={DashboardReducer?.dashboard?.ID}
              setCreateModal={setCreateModal}
              setShowAIInsightsModal={setShowAIInsightsModal}
              setCreateTaskModal={() => {
                if (
                  userReducer?.trello_status === "active" ||
                  userReducer?.clickup_status === "active" ||
                  userReducer?.jira_status === "active"
                ) {
                  setCreateTaskModal(true);
                } else {
                  notification.info({
                    message: t("notifications.48"),
                    icon: (
                      <InfoCircleOutlined
                        style={{ color: theme === "dark" ? "white" : "black" }}
                      />
                    ),
                  });
                }
              }}
              // facebookReplies={facebookReplies}
              // getFacebookReplies={getFacebookReplies}
              setFilters={setFilters}
              selectedPivots={selectedPivots}
              pivotOptions={pivotOptions}
              resetPivotFilters={handleResetPivotFilters}
              resetTopicFilters={handleResetTopicFilters}
              setSelectedPivots={setSelectedPivots}
              setSelectedDecisions={setSelectedDecisions}
              multiLevelOptions={multiLevelOptions}
              levelWisePivotSelections={levelWisePivotSelections}
              setLevelWisePivotSelections={setLevelWisePivotSelections}
              filters={filters}
              topTopics={topTopics}
              handleClearAllTopTopics={handleClearAllTopTopics}
              checkedTopicIds={checkedTopicIds}
              setCheckedTopicIds={setCheckedTopicIds}
              selectedTopicIds={selectedTopicIds}
              setSelectedTopicIds={setSelectedTopicIds}
              feedbackUpdated={feedbackUpdated}
              setTopicChanged={setTopicChanged}
              selectedTopicFromBars={selectedTopicFromBars}
              setSelectedTopicFromBars={setSelectedTopicFromBars}
              npsScale={npsScale}
              cursors={cursors}
              setCursorNext={setCursorNext}
              backWardCursors={backWardCursors}
              disableSelection={topTopicsLoading}
              setHideEmptyReviews={setHideEmptyReviewsTopics}
              hideEmptyReviews={hideEmptyReviewsTopics}
              resetReviewsPage={resetReviewsPageTopics}
              setResetReviewsPage={setResetReviewsPageTopics}
              setSelectedReviewIds={setSelectedReviewIds}
              selectedReviewIDs={selectedReviewIDs}
              setTweetsCheckList={setTweetsCheckList}
              setUsersCheckList={setUsersCheckList}
              tweetsCheckList={tweetsCheckList}
              usersCheckList={usersCheckList}
            />
          </div>
        </BoardCard>
      </div>
      {!shared && (DashboardId || DashboardReducer?.dashboard?.ID) && (
        <AIInsightsModal
          visible={showAIInsightsModal}
          onClose={() => setShowAIInsightsModal(false)}
          onSubmit={handleAIInsightGeneration}
          dashboardId={parseInt(DashboardId || DashboardReducer?.dashboard?.ID)}
          pivotOptions={generationPivotOptions}
          isDark={theme === "dark"}
        />
      )}
      <Modal
        showModal={createModal}
        onClose={() => {
          setCreateModal(false);
          setInsightTxt("");
          setinsightTitleTxt("");
        }}
        onSave={handleCreateInsight}
        showSaveButton={true}
        textonButton={t("button.7")}
        titleAsset=""
        title={
          <span className={styles.insightTitle}>
            {t("selected_dashboard_page.65")}{" "}
            <img
              className={styles.message_img}
              src={
                theme === "dark"
                  ? "/assets/info1.svg"
                  : "/assets/info1_black.svg"
              }
              width={20}
              height={20}
              onClick={() => {
                const win = window.open(
                  "https://pivony.notion.site/Insight-Creation-160faa1a90cc4191baf11fb62c88d808",
                  "_blank"
                );
                win.focus();
              }}
            />
          </span>
        }
        widthofmodal="420px"
        disabled={disabled}
        loadingSaveClick={createInsightLoading}
      >
        <div className={styles.titles}>
          <Input.TextArea
            style={{
              height: "2px",
              marginBottom: "7px",
              width: "400px",
              background: "transparent",
              borderColor: "#6f6c99",
              borderRadius: "10px",
              color: theme === "dark" ? "white" : "black",
            }}
            placeholder={t("placeholder.14")}
            // onKeyPress={(e) => keyPressed(e, handleCreateInsight)}
            onChange={(e) => setinsightTitleTxt(e.target.value)}
            value={insightTitleTxt}
          />
        </div>
        <div className={styles.titles}>
          <Input.TextArea
            style={{
              height: "130px",
              width: "400px",
              background: "transparent",
              color: theme === "dark" ? "white" : "black",
              borderColor: "#6f6c99",
              borderRadius: "10px",
            }}
            placeholder={t("placeholder.15")}
            // onKeyPress={(e) => keyPressed(e, handleCreateInsight)}
            onChange={(e) => setInsightTxt(e.target.value)}
            value={insightTxt}
          />
        </div>
      </Modal>
      {subscriptionStatus?.trello_status === "active" && (
        <CreateTaskTrelloModal
          subscriptionStatus={subscriptionStatus}
          user={user}
          showModal={createTaskModal}
          onClose={() => setCreateTaskModal(false)}
          dashboardId={DashboardReducer?.dashboard?.ID}
          getSearchState={getSearchState}
          timeInterval={timeInterval}
          total_num_docs={numReviews}
          reporter={userReducer.IsExpert ? 2 : 1}
        />
      )}
      {userReducer?.jira_status === "active" && (
        <CreateTaskJiraModal
          userReducer={userReducer}
          user={user}
          showModal={createTaskModal}
          onClose={() => setCreateTaskModal(false)}
          dashboardId={DashboardReducer?.dashboard?.ID}
          getSearchState={getSearchState}
          timeInterval={timeInterval}
          total_num_docs={numReviews}
          reporter={userReducer.IsExpert ? 2 : 1}
        />
      )}
      {subscriptionStatus?.clickup_status === "active" && (
        <CreateTaskClickupModal
          subscriptionStatus={subscriptionStatus}
          user={user}
          showModal={createTaskModal}
          onClose={() => setCreateTaskModal(false)}
          dashboardId={DashboardReducer?.dashboard?.ID}
          getSearchState={getSearchState}
          timeInterval={timeInterval}
          total_num_docs={numReviews}
          reporter={userReducer.IsExpert ? 2 : 1}
        />
      )}
      {showFileTypePopup && (
        <FileTypePopup
          loading={downloadDataLoading}
          setShowFileTypePopup={setShowFileTypePopup}
          downloadData={downloadData}
          fileType={fileType}
          setFileType={setFileType}
          onlySequences={onlySequences}
          setOnlySequences={setOnlySequences}
        />
      )}
      {showAdditionalSearchPopup && (
        <Modal
          showModal={showAdditionalSearchPopup}
          onClose={() => {
            setShowAdditionalSearchPopup(false);
          }}
          onDiscard={() => {
            setShowAdditionalSearchPopup(false);
            const selectedTags = params.has("keyword")
              ? JSON.parse(params.get("keyword"))
              : [];
            updateQParams(
              "keyword",
              JSON.stringify([
                ...selectedTags.filter((item) => item.type !== "search"),
                { label: searchWord, type: "search" },
              ])
            );
            dispatch({
              type: actions.UPDATE_SEARCH_STATE,
              payload: {
                chosenKeywords: [{ label: searchWord, type: "search" }],
              },
            });
            setSearchWord("");
          }}
          onSave={() => {
            setShowAdditionalSearchPopup(false);
            const selectedTags = params.has("keyword")
              ? JSON.parse(params.get("keyword"))
              : [];
            const nextSelectedTags = [
              ...selectedTags,
              { label: searchWord, type: "search" },
            ];
            params.delete("keyword");
            params.append("keyword", JSON.stringify(nextSelectedTags));
            history.push({ search: params.toString() });
            dispatch({
              type: actions.UPDATE_SEARCH_STATE,
              payload: {
                chosenKeywords: nextSelectedTags,
              },
            });
            setSearchWord("");
          }}
          showSaveButton={true}
          showCancelButton={true}
          textonButton={t("selected_dashboard_page.135")}
          cancelButtonText={t("selected_dashboard_page.134")}
          titleAsset=""
          title={t("selected_dashboard_page.132")}
          widthofmodal="460px"
        >
          <p>{t("selected_dashboard_page.133")}</p>
        </Modal>
      )}

      {/* Delete Topic Modal */}
      <Modal
        showModal={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onSave={handleDeleteTopic}
        showSaveButton={true}
        showCancelButton={true}
        textonButton={t("Yes, delete")}
        cancelButtonText={t("common.cancel")}
        title={t("Delete Topic")}
        widthofmodal="400px"
        disabled={deleteLoading}
        loadingSaveClick={deleteLoading}
        titleAsset=""
      >
        <div style={{ fontSize: 16, marginBottom: 12 }}>
          {t("Are you sure you want to delete")} <b>{selectedTopic?.label}</b>?<br/>
          {t("This can't be undone.")}
        </div>
      </Modal>

      {/* Reposition Txopic Modal */}
      {isCombinedView && (
        <Modal
          showModal={repositionModalOpen}
          onClose={() => setRepositionModalOpen(false)}
          onSave={handleRepositionTopic}
          showSaveButton={true}
          showCancelButton={true}
          textonButton={t("Confirm")}
          cancelButtonText={t("common.cancel")}
          title={t("Reposition Topic")}
          widthofmodal="400px"
          disabled={repositionLoading}
          loadingSaveClick={repositionLoading}
          titleAsset=""
          className={styles.repositionModal}
        >
          <div className={styles.repositionHeader}>{t("Current Parent")}</div>
          <div className={styles.repositionParentTagRow}>
            <Tag color="blue" className={styles.repositionParentTag}>
              {findParentNameById(selectedTopic?.parent_id, parentOptions) || t("No Parent (Root)")}
            </Tag>
          </div>
          <div className={styles.repositionRow}>
            <div className={styles.repositionCol}>
              <div className={styles.repositionLabel}>{t("New parent")}</div>
              {parentOptionsLoading ? (
                <div className={styles.repositionInput} style={{textAlign:'center',paddingTop:'0.5rem',paddingBottom:'0.5rem'}}>
                  <span className={styles.repositionLoader}></span>
                  {t("Loading...")}
                </div>
              ) : (
                <>
                  <div className={styles.repositionModal}>
                    <TreeSelect
                      style={{ width: '100%' }}
                      value={selectedParent === 'none' ? undefined : selectedParent}
                      dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
                      placeholder={t("Select new parent (search or browse)")}
                      allowClear
                      showSearch
                      onChange={val => setSelectedParent(val || 'none')}
                      notFoundContent={<span className={styles.repositionEmptyTopics}>{t("No topics available")}</span>}
                      filterTreeNode={(input, treeNode) =>
                        (treeNode.title || '').toLowerCase().includes(input.toLowerCase())
                      }
                      disabled={parentOptions.length === 0}
                      getPopupContainer={trigger => trigger.parentNode}
                      treeDefaultExpandParent
                      treeCheckable={false}
                      treeLine
                      treeDataSimpleMode={false}
                      treeData={parentOptions.map(node => ({
                        ...node,
                        disabled: node.value === selectedTopic?.id,
                        children: node.children ? node.children.map(child => ({
                          ...child,
                          disabled: child.value === selectedTopic?.id
                        })) : undefined
                      }))}
                      treeNodeLabelProp="title"
                    />
                  </div>
                  {/* Root checkbox */}
                  <div style={{ margin: '10px 0 0 2px', display: 'flex', alignItems: 'center' }}>
                    <input
                      type="checkbox"
                      className={styles.parentCheckbox}
                      checked={selectedParent === 'none'}
                      onChange={e => setSelectedParent(e.target.checked ? 'none' : null)}
                      id="set-root-checkbox"
                    />
                    <label htmlFor="set-root-checkbox" style={{ color: 'inherit', fontSize: 14 }}>
                      {t('Set as root (no parent)')}
                    </label>
                  </div>
                  {/* Summary under the TreeSelect */}
                  {selectedParent !== null && selectedParent !== selectedTopic?.parent_id && (
                    <div className={styles.repositionSummary}>
                      {t("This topic will be moved under") + ' '}
                      <b>{
                        selectedParent && selectedParent !== 'none'
                          ? findParentNameById(selectedParent, parentOptions)
                          : t("No parent (Root)")
                      }</b>
                      .
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          {repositionError && <div className={styles.repositionError}>{repositionError}</div>}
        </Modal>
      )}

      
    </div>
  );
};

export default SelectedTopicInfo;
